export const en = {
  ACCEPT: 'Accept',
  ACCOUNT: 'Account',
  ACCOUNT_SETTINGS: 'Account Settings',
  APP_SETTINGS: 'Settings',
  ADD_CONTENT: 'Add Content',
  ADD_MIND_MAP_FILL_IN_BOX: 'Add Fillable Box',
  ADD_MIND_MAP_LABLE_BOX: 'Add Labelling Box',
  ADMIN_TASK: 'Admin Task',
  AI_MODEL: 'AI Model',
  AI_SUGGEST: 'Generate AI Content Suggestions',
  FINISHED: 'Finished',
  ERROR: 'Error',
  AI_MODEL_WAIT_TIME: 'AI model needs 1-2 minutes to generate content suggestions',
  AI_GENERATED_RESPONSES: 'AI Generated Responses',
  SELECT_RESPONSES: 'Select Responses',
  AI_MODEL_USED: 'Model: {0}',
  AI_RESPONSE_NUMBER: 'Response {0}',
  AI_REVIEW_SUGGESTIONS_TITLE: 'AI Content Suggestions',
  AI_REVIEW_INTRO: 'Review and edit the suggestions below, then add the ones you want.',
  AI_SUGGESTION_INCLUDE: 'Add this suggestion',
  AI_SUGGESTION_CONTENT: 'Content',
  AI_FILL_ANSWER: 'Answer {0}',
  AI_TABLE_COLUMNS: 'Columns (comma-separated)',
  AI_TABLE_ROWS: 'Rows (comma-separated)',
  AI_ADD_SELECTED: 'Add Selected',
  AI_NO_SUGGESTION_SELECTED: 'Please select at least one suggestion to add.',
  AI_NO_SUGGESTIONS: 'The AI did not return any usable suggestions. Please try again.',
  AI_PARSE_ERROR: 'Could not read the AI response. Please try again.',
  AI_SUGGESTIONS_ADDED: 'Added {0} content item(s).',
  AI_SUGGEST_BUTTON: 'AI Suggestions',
  AI_SUGGEST_RENAME_TITLE: 'Update Hotspot Name',
  AI_SUGGEST_RENAME_REMINDER: 'This hotspot is still using the default name "{0}". AI Suggestions generates content based on the hotspot name, so please rename it to the actual hotspot name first for more relevant results.',
  CONTINUE_ANYWAY: 'Continue Anyway',
  AI_START_GENERATION: 'Start AI Suggestions',
  AI_GENERATING: 'AI is generating content suggestions, please wait (about 1–2 minutes)…',
  AI_CHANGE_OPTIONS: 'Change options',
  AI_SETUP_INTRO: 'Choose the options below, then start generating AI content suggestions.',
  AI_GENERATE_FAILED: 'AI generation failed. Please try again.',
  AI_CONTENT_TYPES_TO_GENERATE: 'Content types to suggest',
  AI_CONTENT_TYPES_PLACEHOLDER: 'Leave empty to allow all types',
  AI_CURRICULUM_KLA: 'Key Learning Area',
  AI_CURRICULUM_SUBJECT: 'Subject',
  AI_CURRICULUM_LEVEL: 'Student level',
  AI_CURRICULUM_NONE: 'Not specified',
  AI_CURRICULUM_CROSS_LEVEL: 'Cross-level',
  AI_CURRICULUM_HINT: 'When set, the AI grounds its suggestions in Hong Kong EDB curriculum documents (optional).',
  AI_OUTPUT_LANGUAGE: 'Output language',
  AI_OUTPUT_LANGUAGE_AUTO: 'Auto (follow curriculum)',
  AI_EXCEED_MAX_COMPONENT: 'Cannot add: {0} existing items, the limit is {1}; at most {2} more can be added. Please deselect some suggestions.',
  AI_SUGGESTED_QUESTIONS: 'AI Suggested Questions',
  ALL_SCHOOLS: 'All Schools',
  ALL_USERS: 'All Users',
  ANSWER: 'Answer',
  EXPORT_ALL_STUDENT_ANSWERS: 'Export all student answers to Excel',
  EXPORT_ALL_AI_SCORES: 'Export all student AI Scores',
  EXPORT_ALL_MARKS: 'Export all student Marks',
  NO_SCORE_TO_EXPORT: 'No student has a score to export yet',
  ANSWER_NOT_ALL_FILLED: 'Please provide at least 4 files for the answers',
  ARCHIVE: 'Download to Excel',
  AUTHOR: 'Author',
  BACK: 'Back',
  BACK_TO_LOCALE_LIST: 'Back to LOCALE List',
  CANCEL: 'Cancel',
  DO_NOT_SHOW_AGAIN: "Don't Show Again",
  CATEGORY: 'Category',
  CATEGORY_CREATION: 'Creation',
  CATEGORY_EXPERIENCE: 'Experience',
  CATEGORY_EXPERIMENT: 'Experiment',
  CATEGORY_EXPLORATION: 'Exploration',
  CATEGORY_NONE: 'None',
  CATEGORY_KNOWLEDGE: 'Knowledge',
  CHANGE: 'Change',
  CHANGE_PASSWORD: 'Change Password',
  CHOICE: 'Choice',
  CLEAR: 'Clear',
  CLOSE: 'Close',
  COLOR: 'Color',
  COLUMN: 'Column',
  COMPARE_ANSWERS: 'Show All Student Answers',
  CONTENT: 'Content',
  CONTENT_NAME: 'Title',
  CONTENT_PHOTO_FILE_INSTRUCTION: 'If you would like to describe more than 1 photo, you may create multiple photo descriptions. \n Photo is not necessary but recommended to enhance learning motivation. \n The maximum characters for each photo description is 2000.',
  CONTENT_TYPE: 'Content Type',
  CREATE_CONTENT: 'Create Content',
  CONTENT_TYPE_GROUP_PRESENTATION: 'Presentation Types',
  CONTENT_TYPE_GROUP_PRESENTATION_DESCRIPTION: 'Used to present information or media only',
  CONTENT_TYPE_GROUP_RESPONSE: 'Student Response Types',
  CONTENT_TYPE_GROUP_RESPONSE_DESCRIPTION: 'Used when students need to answer or submit work',
  CONTINUE_EDITING: 'Continue Editing',
  CORRECT: 'Correct',
  CORRECT_ANSWER: 'Correct Answer',
  CORRECT_ANSWER_CONTECT_NOT_FILLED: 'Please fill in the correct answers',
  CORRECT_ANSWER_NOT_SELECTED: 'Please select at least one correct answer(s)',
  COVER_IMAGE: 'Cover Image',
  CREATE: 'Create',
  CREATE_SCHOOL: 'Create School',
  CREATE_USER: 'Create User',
  PLATFORM_ADMIN_ROLE: 'CLST Administrator',
  PLATFORM_ADMIN_CREATE_WARNING: 'Warning: this account can manage data across all schools. Create it only for authorized CLST platform staff.',
  CREATED: 'Created',
  DARK_MODE: 'Dark Mode',
  DECLINE: 'Decline',
  DELETE: 'Delete',
  DELETE_CONTENT: 'Delete Content',
  DELETE_FAILED: 'Delete Failed',
  DELETE_FILE: 'Delete File',
  DELETE_HOTSPOT: 'Delete Hotspot',
  DELETE_LOCALE: 'Delete LOCALE',
  DELETE_MIND_MAP_BOX: 'Delete Box',
  DELETE_MIND_MAP_LINK: 'Delete Link',
  DELETE_REMINDER: 'Files cannot be recovered after deletion, are you sure you want to delete the selected item?',
  DELETED: 'Deleted',
  DESCRIPTION: 'Description',
  DESCRIPTION_AUDIO: 'Description of Audio',
  DESCRIPTION_FILL_IN_THE_BLANK_AFTER: 'Description after Fill-in-the-Blank',
  DESCRIPTION_FILL_IN_THE_BLANK_BEFORE: 'Description before Fill-in-the-Blank',
  DESCRIPTION_IMAGE: 'Description of Image',
  DESCRIPTION_NOT_FILLED: 'Please fill in the description',
  DESCRIPTION_QUESTION: 'Question',
  DESCRIPTION_TAKE_PHOTO: 'Question / description for taking a photo',
  DESCRIPTION_TAKE_RECORD: 'Question / description for voice recording',
  DESCRIPTION_DRAWING_TASK: 'Question / description for drawing task',
  DESCRIPTION_TEXT: 'Description',
  DESCRIPTION_VIDEO: 'Description of Video',
  DETAILS: 'Basic Information',
  DIFFICULTY: 'Difficulty',
  DISCARD: 'Discard',
  DISCARD_CHANGES: 'Discard Changes',
  DISPLAY_NAME: 'Display Name',
  DISPLAY_NAME_FOR_LOCALE: 'Author Name of the LOCALE',
  DISPLAY_NAME_BLANK_REMINDER: 'Display Name cannot be blank',
  DONE: 'Done',
  DONE_EDITING: 'Finish Editing',
  DOWNLOAD: 'Download',
  EDIT: 'Edit',
  EDIT_PROFILE: 'Edit Profile',
  EDIT_SCORE: 'Edit Score',
  EDIT_CONTENT: 'Edit Content',
  EDIT_HOTSPOTS: 'Edit Hotspots',
  EDIT_USER: 'Edit User',
  EDIT_LOCALE: 'Edit LOCALE',
  EMAIL: 'Email',
  EMAIL_INCORRECT_REMINDER: 'Incorrect Email format',
  EMPTY_CONTENT_PROMPT: 'Are you sure not to add any content?',
  EMPTY_CONTENT_REMINDER: 'There is no content in this Hotspot, please click "+" to create',
  EMPTY_HOTSPOT_PROMPT: 'Are you sure not to add any Hotspots?',
  EMPTY_HOTSPOT_REMINDER: 'There is no Hotspot in this LOCALE, please click "New Hotspot" to add',
  EMPTY_SUBMISSION_REMINDER: "No answer has been submitted. To view students' answers here, please ask them to submit answers via their Apps",
  EMPTY_TAG_PROMPT: 'Are you sure not to add any Tags?',
  EMPTY_URL: 'Video URL cannot be empty',
  EXCEED_MAX_COMPONENT: 'The content limit has been reached; no more can be added.',
  EXCEED_MAX_HOTSPOT: 'EXCEED_MAX_HOTSPOT',
  REMARK: 'Remark',
  ACTION: 'Action',
  EXIT: 'Exit',
  EXPLORE: 'Explore',
  LOCATE_ON_MAP: 'Locate on Map',
  SHOW_CARD_SUBJECTS: 'Show Subjects',
  LOCALE_SETTINGS: 'LOCALE Settings',
  LOCALE_SETTINGS_PUBLISHING: 'Publishing',
  LOCALE_SETTINGS_HOTSPOT_UNLOCK: 'Hotspot Unlock',
  LOCALE_SETTINGS_GAME_MODE: 'Game Mode',
  LOCALE_SETTINGS_AI_FEATURES: 'AI Features',
  FILE_TYPE: 'File Type',
  FILL_AT_LEAST_ONE: 'Please fill in at least one textfield',
  FILL_IN_MIND_MAP: 'Fill-in-the-Blank Mind Map',
  FILL_IN_MIND_MAP_DESCRIPTION: 'Please fill in the Mind Map',
  FILL_IN_THE_BLANK: 'Fill in the Blanks',
  FILL_IN_THE_BLANK_DESCRIPTION: 'Please fill in the blank',
  FINISH: 'Finish',
  HOTSPOT_CONTENT_3D_MODEL: '3D Model',
  HOTSPOT_CONTENT_3D_MODEL_DESCRIPTION: 'Upload and display 3D model content',
  HOTSPOT_CONTENT_3D_MODEL_PREVIEW: '3D Model Preview',
  HOTSPOT_CONTENT_3D_MODEL_GENERATING: '3D model generation takes 5-10 minutes. You can leave this dialog during the process without affecting the generation progress.',
  NO_3D_QUOTA_CONTACT_ADMIN: 'There are no remaining 3D model quotas. Please purchase additional quotas.',
  REMAINING_QUOTA: 'Remaining quota',
  THIS_IS_3D_MODEL_TIP: 'This is the 3D model preview.',
  NO_3D_MODEL_YET: '3D model not generated yet.',
  NO_IMAGE_UPLOADED_YET: 'Please upload an image on the left to start generating 3D model.',
  GENERATE_3D_MODEL: 'Generate 3D Model',
  GENERATING_3D_MODEL: 'Generating 3D Model...',
  PLEASE_SUBMIT_TO_GENERATE_3D_MODEL: 'Please submit to generate the 3D model',
  CHECKING_FOR_3D_UPDATE: 'Refreshing 3D model status...',
  DOWNLOAD_GLB: 'Download GLB',
  VIEW_3D_FULLSCREEN: 'View fullscreen',
  EXIT_3D_FULLSCREEN: 'Exit fullscreen',
  PREVIEW_IMAGE: 'Preview Image:',
  MODEL_3D_LOADED_SUCCESS: '3D model loaded successfully!',
  MODEL_3D_LOAD_FAILED: 'Failed to load 3D model',
  MODEL_3D_NO_AVAILABLE: 'No 3D model available to view.',
  MODEL_3D_DEFAULT_NAME: '3D Model',
  UPLOAD_IMAGE_TO_GENERATE_3D: 'Upload an image to generate the 3D model',
  GEN3D_UPLOAD_INFO: 'Best results: one single object, sharp and well lit, on a clean background. A PNG with transparent background works best. After uploading, set the options on the right and press "Generate 3D Model".',
  GEN3D_SETTINGS: '3D generation settings',
  GEN3D_HOW_IT_WORKS: 'Upload a photo of a single object, set the options on the right and press "Generate 3D Model" — it takes about 5-10 minutes. You can close this dialog — generation continues in the background; the icon at the top right of the map shows progress and brings you back here.',
  GEN3D_PARAMS_LOCKED: 'Settings are locked while generating — these are the parameters this model is being built with.',
  GEN3D_NO_PRIVILEGE: '3D model generation is not enabled for this school, or its subscription is not active. Please contact your administrator.',
  GEN3D_QUOTA_UNKNOWN: 'Remaining quota could not be read; you can still start a generation and the server makes the final check.',
  GEN3D_START_REQUIRED: 'Press "Generate 3D Model" to start the generation before saving this 3D component.',
  GEN3D_PROMPT_LABEL: 'Material / style hint',
  GEN3D_PROMPT_INFO: 'Describe the object material and colours (e.g. "glossy ceramic", "matte plastic", "brushed metal"). This improves the generated textures. Optional.',
  GEN3D_PROMPT_PLACEHOLDER: 'e.g. glossy ceramic teapot, dark green',
  GEN3D_ENGINE_LABEL: 'Generation engine',
  GEN3D_ENGINE_INFO: 'Which built-in engine builds the model. Standard: all-round quality with realistic PBR textures (default). Alternative: a second engine — try it if the result is unsatisfactory, or to compare.',
  GEN3D_ENGINE_STANDARD: 'Standard',
  GEN3D_ENGINE_ALTERNATIVE: 'Alternative',
  GEN3D_SELF_PROGRESS: 'Generating the 3D asset with the built-in engine...',
  GEN3D_QUOTA_TOOLTIP: 'Your school can still generate {0} 3D models in this subscription (total quota {1}). Each successful generation (either engine) uses one quota; contact your administrator when it runs out.',
  GEN3D_QUALITY_LABEL: 'Model quality',
  GEN3D_QUALITY_INFO: 'The generated model is always compressed before saving so it loads quickly on student devices. High keeps the most detail; Mid and Low shrink the file further (fewer polygons, smaller textures) for faster loading.',
  GEN3D_QUALITY_HIGH: 'High',
  GEN3D_QUALITY_MID: 'Mid',
  GEN3D_QUALITY_LOW: 'Low',
  GEN3D_OPTIMIZING: 'Compressing the model...',
  GEN3D_MODE_SELF: 'built-in engine',
  GEN3D_MODE_CLOUD: 'cloud service',
  GEN3D_TIER_LABEL: 'Generation quality',
  GEN3D_TIER_INFO: 'Applies to cloud generation (and to the automatic cloud fallback). Standard balances quality and speed; Rapid is faster with simpler results; Pro unlocks face count and type below.',
  GEN3D_TIER_STANDARD: 'Standard',
  GEN3D_TIER_RAPID: 'Rapid',
  GEN3D_TIER_PRO: 'Pro',
  GEN3D_PBR_LABEL: 'PBR materials',
  GEN3D_PBR_INFO: 'Physically-based rendering textures (metallic / roughness) for more realistic surfaces. Recommended on.',
  GEN3D_FACE_COUNT_LABEL: 'Max faces',
  GEN3D_FACE_COUNT_INFO: 'Upper bound of the model polygon count (Pro tier only). More faces mean more detail but heavier files for student devices.',
  GEN3D_TYPE_LABEL: 'Generation type',
  GEN3D_TYPE_INFO: 'Normal keeps full detail; LowPoly produces a lighter, stylised model that loads faster on student devices (Pro tier only).',
  GEN3D_TYPE_NORMAL: 'Normal',
  GEN3D_TYPE_LOWPOLY: 'LowPoly',
  GEN3D_PHASE_SUBMITTING: 'Submitting...',
  GEN3D_PHASE_QUEUED: 'Waiting for the server...',
  GEN3D_PHASE_PREPARING: 'Preparing...',
  GEN3D_PHASE_GENERATING: 'Building the 3D model...',
  GEN3D_PHASE_FINALIZING: 'Finishing up...',
  GEN3D_PHASE_IMPORTING: 'Saving the model...',
  GEN3D_PHASE_CLOUD: 'Generating in the cloud...',
  GEN3D_PHASE_FAILED: 'Generation failed',
  GEN3D_SLOW_NOTE: 'Taking longer than usual — still working...',
  GEN3D_BG_REMINDER: 'You can close this dialog — generation continues in the background. The icon at the top right of the map shows progress and brings you back here.',
  GEN3D_FALLBACK_NOTICE: 'Built-in engine unavailable — switched to cloud generation automatically.',
  GEN3D_READY_NOTICE: '3D model is ready.',
  GEN3D_RETRY: 'Retry',
  GEN3D_CANCEL: 'Cancel generation',
  GEN3D_CANCEL_CONFIRM_TITLE: 'Cancel 3D generation',
  GEN3D_CANCEL_CONFIRM_BODY: 'Stop generating this 3D model? The uploaded image will be removed too — upload a new image to start again.',
  GEN3D_CANCELLED: '3D generation cancelled.',
  GEN3D_CANCELLED_REMOTE: '3D generation was cancelled on the server.',
  GEN3D_DELETE_MODEL: 'Delete model',
  GEN3D_DELETE_CONFIRM_TITLE: 'Delete 3D model',
  GEN3D_DELETE_CONFIRM_BODY: 'Delete this 3D model? The model and its source image will be removed, and you can upload a new image to generate again. Used quota is not refunded.',
  GEN3D_DELETED: '3D model deleted.',
  GEN3D_PHASE_CANCELLED: 'Generation cancelled',
  GEN3D_REGENERATE: 'Regenerate',
  GEN3D_CANCELLED_HINT: 'Adjust the settings above if needed, then regenerate. Replacing the image also restarts generation.',
  GEN3D_JOBS_IN_PROGRESS: '{0} 3D model(s) generating',
  GEN3D_JOB_OPEN_HINT: 'Click to view progress',
  GEN3D_CLEANUP: 'Clean up',
  GEN3D_CLEANUP_RUNNING: 'Checking...',
  GEN3D_CLEANUP_HINT: 'Check each job with the server and remove ones that were cancelled or already finished.',
  FORGET_PASSWORD: 'Forgot Password',
  GET_TRANSCRIPTION: 'Get Transcription',
  HOTSPOT_INVISIBLE: 'Hotspot Invisible',
  HOTSPOT_LIST: 'Hotspot List',
  HOTSPOT_EDIT: 'Edit Hotspot Details',
  HOTSPOT_EDIT_REMINDER_1: 'This hotspot does not have any content, and position not yet defined, are you sure to go back?',
  HOTSPOT_EDIT_REMINDER_2: 'Are you sure to go back?',
  HOTSPOT_EMPTY_NAME_REMINDER: 'Hotspot name cannot be blank',
  HOTSPOT_VISIBILITY: 'Hotspot Visible',
  HOTSPOT_VISIBLE: 'Normal',
  IMAGE_NOT_FILLED: 'Are you sure to leave without uploading an image?',
  IMAGE_REQUIRED: 'Please upload an image',
  IMAGE_SEARCH: 'Search Image',
  INPUT_KEYWORD: 'Input Keyword',
  KEYWORD: 'keyword',
  KLA_FULL: 'Key Learning Area',
  KLA_SHORT: 'KLA',
  LANGUAGE: 'Language',
  LANGUAGE_ENGLISH_HELPER: 'Use English throughout the composer.',
  LANGUAGE_ENGLISH_LABEL: 'English',
  LAST_LOGIN_TIME: 'Last Login Time',
  LATEST_SUBMISSION: 'Latest Submission',
  LATITUDE: 'Latitude',
  LINK_OTHER_MIND_MAP_BOX: 'Link other Mind Map box',
  LOCALE_COVER_BLANK_REMINDER: 'Please upload a cover image',
  LOCALE_KLA_BLANK_REMINDER: 'Please select a KLA',
  LOCALE_MAP_BLANK_REMINDER: 'Please set a LOCALE region',
  LOCALE_MAP_MAX_SIZE_REMINDER: 'LOCALE region is too wide (length/ width bigger than 30km)',
  LOCALE_MAP_MIN_SIZE_REMINDER: 'LOCALE region is too narrow (length/ width smaller than 1000m)',
  LOCALE_MAP_ZOOM_LV_REMINDER: 'Map Zoom Level is too small and not suitable for field study. Zoom Level greater than 15 is recommended.',
  LOCALE_NAME_BLANK_REMINDER: 'LOCALE name cannot be blank',
  LOCALE_SEARCH_RESULT_NONE: 'There is no result, please try another search',
  LOCALE_SEARCH_TEXT_PLACEHOLDER: 'Keyword or School Name',
  LOCALE_SUBJECT_BLANK_REMINDER: 'Please select a Subject',
  LOCATION: 'Define Field Trip Area',
  LOCATION_SEARCH: 'Location Search',
  LOGIN: 'Login',
  LOGOUT: 'Logout',
  LONGITUDE: 'Longitude',
  MAP_SIZE: 'Map Size (W*H)',
  MATCHVIEW_REMINDER: 'Change the size and location of the selected region to an approximated region of the current mapview',
  DEFINE_FIELD_TRIP_AREA: 'Define Field Trip Area',
  MC_OF_PICTURES: 'MC Question for Pictures',
  MC_OF_PICTURES_DESCRIPTION: 'Please select the most suitable picture answer',
  MC_OF_PICTURES_MULTI: 'Multiple MC Question for Pictures',
  MC_OF_PICTURES_MULTI_DESCRIPTION: 'Please select multiple picture answers',
  MC_OF_TEXTS: 'MC Question for Text',
  MC_OF_TEXTS_DESCRIPTION: 'Please select the most suitable text answer',
  MC_OF_TEXTS_MULTI: 'Multiple MC Question for Texts',
  MC_OF_TEXTS_MULTI_DESCRIPTION: 'Please select multiple text answers',
  MIND_MAP_BOX: 'Mind Map Box',
  MIND_MAP_FILL_IN_BOX: 'Filable Box',
  MIND_MAP_LABLE_BOX: 'Labelling Box',
  MOVE_DOWN: 'Move Down',
  MOVE_UP: 'Move Up',
  MOVIECLIP: 'Movie Clip',
  MOVIECLIP_URL: 'Movie Clip URL',
  MOVIECLIP_DESCRIPTION: 'Play Movie Clip',
  MOVIECLIP_SOURCE: 'Movie Clip Source',
  MOVIECLIP_TAB_YOUTUBE: 'YouTube URL',
  MOVIECLIP_TAB_UPLOAD: 'Upload Video',
  MOVIECLIP_UPLOAD_INSTRUCTION: 'MP4 video, H.264 + AAC, up to 200MB.\nUploaded video is downloaded with the LOCALE and plays offline.',
  MOVIECLIP_APP_VERSION_NOTICE: 'Uploaded video requires EduVenture-AI app version %s or later. Students on an older app will not be able to play this clip — use a YouTube URL if you need to support older versions.',
  MOVIECLIP_SWITCH_TITLE: 'Change video source',
  MOVIECLIP_SWITCH_TO_YOUTUBE: 'A movie clip uses either an uploaded video or a YouTube URL, not both. Switching to YouTube will delete the uploaded video.',
  MOVIECLIP_SWITCH_TO_UPLOAD: 'A movie clip uses either an uploaded video or a YouTube URL, not both. Switching to Upload will clear the YouTube URL.',
  VIDEO_NOT_UPLOADED: 'Please upload a video, or switch to the YouTube URL tab',
  MY_SCHOOL: 'My School',
  NAME: 'Name',
  NEW_HOTSPOT: 'New Hotspot',
  TRANSLATE: 'Translate',
  TRANSLATE_LOCALE_TITLE: 'Translate Locale',
  TRANSLATE_SELECT_LANGUAGE: 'Choose the language to translate all text in this locale (its name, all hotspots and their content) into:',
  LANG_TRADITIONAL_CHINESE: 'Traditional Chinese',
  LANG_SIMPLIFIED_CHINESE: 'Simplified Chinese',
  LANG_ENGLISH: 'English',
  TRANSLATE_OVERWRITE_WARNING: 'This overwrites the existing text in place. To keep the original, duplicate the locale first.',
  TRANSLATE_CONFIRM_PROMPT: 'Translate all text in this locale to {0}? This overwrites the existing text in place and cannot be undone.',
  TRANSLATE_CONFIRM: 'Translate',
  TRANSLATING: 'Translating… this may take a moment.',
  TRANSLATE_SUCCESS: 'Translation complete ({0} items updated).',
  TRANSLATE_FAILED: 'Translation failed. Please try again.',
  NEW_LOCALE: 'New LOCALE',
  NEW_PASSWORD: 'New Password',
  NEXT: 'Next',
  NEXT_PAGE: 'Next Page',
  NO: 'No',
  NO_ANSWER_NEEDED: "No answer needed",
  NO_ANSWER: 'No Answer',
  NO_DRAWING: 'No Drawing',
  NO_PHOTO: 'No Photo',
  NO_RECORDING: 'No Recording',
  NO_RESOURCES_IN_CATEGORY: 'No resources in this category.',
  NOT_POSITIONED: 'Position yet to be set',
  NO_CONTENT: 'Empty',
  NTH_FILLED: 'Content cannot be blank',
  OK: 'OK',
  OLD_PASSWORD: 'Old Password',
  OLD_PASSWORD_NOT_CORRECT: 'Incorrect Old Password',
  ONLY_SUPPORT_VIDEO: 'Only youtube videos are supported',
  OVERVIEW: 'LOCALE Overview',
  OWN_SUBMISSION: 'Own Submission',
  PAGE: 'Go To Page',
  PASSWORD: 'Password',
  PASSWORD_REQUIREMENT_0: 'Re-entered password incorrect',
  PASSWORD_REQUIREMENT_1: 'Illegal characters, only letters and numbers allowed',
  PASSWORD_REQUIREMENT_2: 'Password should contain both letters and numbers',
  PASSWORD_REQUIREMENT_3: 'Password should be longer than 6 characters',
  PASSWORD_REQUIREMENT_4: 'Password should be shorter than 30 characters',
  PASSWORD_REQUIREMENT_5: 'Password cannot be blank',
  PASSWORD_UPDATED: 'Password updated',
  PASSWORD_UPDATE_FAIL: 'Password update failed, please check your old password',
  PLEASE_SELECT: 'Please Select',
  POSITION: 'Position',
  POSITIONTED: 'Positioned',
  PREPARING: 'Preparing',
  PREVIOUS_PAGE: 'Previous Page',
  PROFILE: 'Profile',
  PROGRESS: 'Progress',
  PUBLIC: 'Public',
  PUBLISH: 'Publish',
  QR_CODE: 'QR Code',
  QR_CODE_DESC: 'Generate QR Code for students to scan and open this LOCALE in the app',
  DOWNLOAD_QR_CODE: 'Download QR Code',
  QR_CODE_PLATFORM_HINT: 'One code for both iOS and Android. Students who do not have the app yet are offered the download.',
  QR_CODE_UNPUBLISHED_WARNING: 'This LOCALE is not published. Students who scan this code will be told the LOCALE cannot be found.',
  QR_CODE_PUBLISH_PROMPT: 'This LOCALE is not published yet, so a student who scans its QR code will be told the LOCALE cannot be found. Publish it now and show the code?',
  QR_CODE_PUBLISH_CONFIRM: 'Publish and show code',
  QR_CODE_PUBLISHED: 'LOCALE published',
  QR_CODE_PUBLISH_FAILED: 'Could not publish this LOCALE, so no QR code was shown. Please try again — if it keeps failing, check that you may edit this LOCALE and that your school subscription is still valid.',
  QR_CODE_PENDING_UNPUBLISH_WARNING: 'You have switched Publish off. This code works now, but it will stop working as soon as you save.',
  QUESTION: 'Question',
  QUESTION_DESCRIPTION: 'Text or Picture Short Question',
  QUESTION_NOT_FILLED: 'Question not filled',
  RADIUS: 'Radius',
  RE_ENTER_NEW_PASSWORD: 'Re-enter New Password',
  READY: 'Ready',
  REFRESH: 'Refresh',
  REPORT_BUG: 'Report Bug',
  REPORT_BUG_REMINDER: 'Please report bug ',
  RETRIEVE_ANSWERS: 'Review answers',
  ROW: 'Row',
  ROW_COL_NOT_FILLED: 'Row/column cannot be blank',
  SAFE_IMAGE_SEARCH: 'Safe Image Search',
  SAVE: 'Save',
  SCHOOL: 'School',
  SCHOOL_LIST: 'School List',
  SCHOOL_NAME: 'School Name',
  SEARCH: 'Search',
  SEARCH_LOCATION: 'Search Location',
  SELECT: 'Select',
  SELECT_AI_MODEL: ' Select AI Model',
  SELECT_IMAGE: 'Select Image',
  SET_POSITION: 'Set Position',
  SETTINGS: 'Publish & Share Settings',
  LANGUAGE_TRADITIONAL_CHINESE_LABEL: 'Traditional Chinese',
  LANGUAGE_TRADITIONAL_CHINESE_HELPER: 'Use Traditional Chinese throughout the composer.',
  SHARABLE: 'Sharable',
  SHARE: 'Share',
  SHARE_SUBMISSION: 'Create sharing link for this Submission',
  SHARE_SUBMISSION_CONFIRM_MESSAGE: 'You are about to create the sharing link for the submission. Are you sure?',
  SHARING_URL: 'Sharing URL',
  SIMPLE_DESCRIPTION: 'Photo Description',
  SIMPLE_DESCRIPTION_DESCRIPTION: 'Simple Photo Description',
  SORT_BY: 'Sort By',
  SORT_CREATE_DATE_ASC: 'Created (Earliest)',
  SORT_CREATE_DATE_DESC: 'Created (Latest)',
  SORT_MODIFY_DATE_ASC: 'Modified (Earliest)',
  SORT_MODIFY_DATE_DESC: 'Modified (Latest)',
  SORT_NAME_ASC: 'Name (A-Z)',
  SORT_DOWNLOAD_COUNT_ASC: 'Least Downloaded',
  SORT_DOWNLOAD_COUNT_DESC: 'Most Downloaded',
  STORAGE: 'Storage',
  SUBJECT: 'Subject',
  SUBMISSION_DATE: 'Submission Date',
  SUBMISSION_P: 'Submitted People',
  SUBMISSION_S: 'Submission(s)',
  SUBMISSION_TIME: 'Submission Time',
  SUBMISSION_SORT_TIME_DESC: 'Submission Time (Latest to Earliest)',
  SUBMISSION_SORT_TIME_ASC: 'Submission Time (Earliest to Latest)',
  SUBMISSION_SORT_SCORE_DESC: 'Score (High to Low)',
  SUBMISSION_SORT_SCORE_ASC: 'Score (Low to High)',
  SUBMIT: 'Submit',
  SUBMITTED: 'Submitted',
  SWITCH_BACK_TO_CLASSIC_UI: 'Classic User Interface',
  SWITCH_TO_LIST: 'Switch to List',
  SWITCH_TO_MAP: 'Switch to Map',
  TABLE_AND_CELL: 'Add Table ',
  TABLE_AND_CELL_DESCRIPTION: 'Add Question to Table/ Add Statistical Question',
  TAKE_PHOTO: 'Photo-taking Question',
  TAKE_PHOTO_DESCRIPTION: 'Request to Take Photo',
  TAKE_RECORD: 'Recording/ Interviewing',
  TAKE_RECORD_DESCRIPTION: 'Request to Record',
  DRAWING_TASK: 'Drawing Task',
  DRAWING_TASK_DESCRIPTION: 'Students respond by drawing',
  TELEPORT: 'Move to Field Trip Area',
  TELEPORT_REMINDER: 'If the selected region is out of the mapview, move the mapview to the selected region',
  TIME: 'Time',
  TITLE: 'Title',
  TOO_NARROW_REMINDER: 'Distance is too short',
  TOO_WIDE_REMINDER: 'Distance is too long (max 30km), please reduce the field trip area',
  UNSPECIFIED_SUBJECT: 'Unspecified Subject',
  UNSAVED_CHANGES: 'Unsaved Changes',
  UNSAVED_REMINDER: 'There are already some inputs entered. Are you sure you want to cancel? All changes will be lost.',
  UPDATE: 'Update',
  UPDATE_FAILED: 'Update Failed',
  UPDATE_PASSWORD: 'Update Password',
  UPDATE_PROFILE: 'Update Profile',
  UPDATED: 'Updated',
  UPLOAD: 'Upload',
  UPLOAD_COMPLETE: 'Upload Completed',
  UPLOAD_FAILED: 'Upload Failed',
  UPLOAD_FILE_SIZE_REMINDER: 'File Size must be less than',
  UPLOAD_FILE_TYPE_REMINDER: 'File Type not allowed',
  UPLOAD_FILE: 'Upload File',
  // FilePicker's `document` preview (Extra Locale 教師參考手冊): a PDF has
  // no inline preview worth drawing, so the stage shows the file's name and
  // an Open link instead of an <img> that would render as a broken glyph.
  // The school's enrolment key, shown beside the school name in the account
  // menu. It is what students enter to reach the school's LOCALEs, so the
  // hint says what it is FOR, not just what it is.
  SCHOOL_KEY: 'School Key',
  SCHOOL_KEY_HINT: 'Your school key — students enter this to join your school',
  // Split around the value so the key itself can be monospace (these keys
  // mix digits and letters and get read aloud). Renders as
  // "(School key: 9881)".
  SCHOOL_KEY_LABEL_OPEN: '(School key: ',
  SCHOOL_KEY_LABEL_CLOSE: ')',
  UPLOADED_FILE: 'Uploaded file',
  OPEN_FILE: 'Open',
  RECORD_AUDIO: 'Record',
  START_RECORDING: 'Start Recording',
  STOP_RECORDING: 'Stop',
  USE_RECORDING: 'Use Recording',
  RE_RECORD: 'Re-record',
  PROCESSING_RECORDING: 'Processing recording',
  RECORDING_FAILED: 'Recording failed. Please try again.',
  RECORDING_NOT_SUPPORTED: 'Audio recording is not supported in this browser.',
  MICROPHONE_ACCESS_DENIED: 'Microphone access was denied. Please allow microphone access and try again.',
  RECORDING_MAX_LENGTH_REACHED: 'Maximum recording length reached.',
  UPLOAD_LOCAL_FILE: 'Upload Local File',
  UPLOAD_SCREENSHOT: 'Upload Screenshot',
  UPLOADED: 'Uploaded',
  UPLOADING: 'Uploading',
  USER_CHOICE_TAG: "[User's choice]",
  USER_INFORMATION: 'User Information',
  USER_LIST: 'User List',
  USER_ROLE: 'Role',
  USER_ROLE_TEACHER_LOW: 'Standard user',
  USER_ROLE_TEACHER_STANDARD: 'Advanced user',
  USER_ROLE_ADMINISTRATOR: 'Administrator',
  USER_ROLE_STUDENT: 'Student',
  USER_ROLE_UNKNOWN: 'Unknown role',
  USERNAME: 'Username',
  VIEW_AI_RESPONSES_HISTORY: 'View AI responses history',
  VIEW_AI_RESPONSE_HISTORY: 'View AI responses history',
  VIEW_EDIT_DETAILS: 'View/ Edit Details',
  VOICE_NOT_FILLED: 'MP3 file not yet uploaded ',
  VOICE_OVER: 'Voice Over',
  VOICE_OVER_DESCRIPTION: 'Play MP3 file',
  VOICE_TRANSCRIPTION: 'Voice to Text',
  VOICE_TRANSCRIPTION_INSTRUCTION: 'Generate text from the uploaded audio. You can edit the result.',
  VOICE_NO_AUDIO: 'Please upload or record an audio file first.',
  TRANSCRIBE: 'Transcribe',
  TRANSCRIBING: 'Transcribing...',
  TRANSCRIBE_DONE: 'Transcription completed',
  TRANSCRIBE_FAILED: 'Transcription failed. Please try again.',
  YES: 'Yes',
  YOUTUBE_ID_INVALID: 'The Video URL is invalid',
  YOUTUBE_URL_TOO_LONG: 'Video URL is too long',
  ZOOM: 'Zoom',
  ZOOM_IN: 'Zoom In',
  ZOOM_OUT: 'Zoom Out',
  MAP_MONO: 'Mono',
  MAP_SATELLITE: 'Satellite',
  MAP_VECTOR: 'Vector',
  LOCALE_LIST: 'LOCALE List',
  EMAIL_CAN_BE_USED_AS_LOGIN: 'Email can be used as login and retrival of password',
  SUBMIT_BUG_REPORT: 'Bug report will be submitted via Google Form, are you sure to open another webpage and submit the report?',
  PUBLIC_LOCALE_ONLY: 'Public LOCALE Only',
  QA_STATE: 'Audit Status',
  QA_STATE_ANY: 'All',
  QA_STATE_UNCHECKED: 'Not Yet Audited',
  QA_STATE_CHECKED: 'Audited',
  QA_STATE_MINOR: 'Minor Issue',
  QA_STATE_MAJOR: 'Major Issue',
  RETRIEVER: 'RETRIEVER Answer Viewing',
  DROP_FILE_HERE_OR_CLICK_TO_SELECT: 'Click to select file, or drag and drop a file here',
  UPDATED_DATE: 'Updated Time',
  CREATED_DATE: 'Created Time',
  MOVE_TO_HOTSPOT_LOCATION: 'Move to Hotspot Location',
  MOVE_TO_HOTSPOT_LOCATION_REMINDER: 'Mapview will move to Hotspot Location',
  HOTSPOT_HAS_LOCATION: 'Hotspot Location is set',
  METER: 'M',
  REVEAL_CODE: "Reveal Code",
  REVEAL_CODE_REQUIREMENT_0: "Illegal characters, only letters and numbers allowed",
  REVEAL_CODE_REQUIREMENT_1: "Reveal Code should contain both letters and numbers (6 characters)",
  REVEAL_CODE_REQUIREMENT_2: "Reveal Code must contain 6 characters",
  REVEAL_CODE_REQUIREMENT_3: "Reveal Code cannot be blank",
  USE_REVEAL_CODE: "Use hotspots reveal Code",
  ENABLE_REVEAL_CODE: "Enable reveal code",
  ENABLE_REVEAL_CODE_MESSAGE: "Reveal all hotspots by entering the code in EduVenture-AI app.",
  DISABLE_REVEAL_CODE_MESSAGE: "Cannot reveal all hotspots in EduVenture-AI app.",
  REVEAL_CODE_HINT: "When enabled, a code can be entered in EduVenture-AI to reveal all hotspots",
  AUTO_SHARE_ASSESSMENT: "Distribute assessment to students",
  AUTO_SHARE_VIA_DEVICE: "Send after AI completes assessment",
  AUTO_SHARE_VIA_EDCITY: "Send to student after finishing the assessment via EdCity",
  AUTO_SHARE_VIA_BOTH: "Send to student after finishing the assessment via both device and EdCity",
  AUTO_SHARE_ASSESSMENT_HELP: "Automatically share assessment results with students after AI assessment is complete",
  AVATAR_INTERACTION: "Avatar interaction (Game mode)",
  AVATAR_INTERACTION_APP_VERSION_REQUIRED: "This feature requires EduVenture-AI app v2.0.4 or later.",
  MOOD_ENABLED: "Emoji Status",
  MOOD_ENABLED_HELP: "When enabled, students can set their own Emoji Status and view another student's Emoji Status by tapping their avatar in Game mode.",
  NUDGE_ENABLED: "Nudge",
  NUDGE_ENABLED_HELP: "When enabled, tapping another student's avatar offers a Nudge that vibrates their device. Nudges are rate-limited and recorded.",
  CHAT_TEACHER_TO_STUDENT: "Chat: teacher to student",
  CHAT_STUDENT_TO_STUDENT: "Chat: student to student",
  CHAT_STUDENT_TO_TEACHER: "Chat: student to teacher",
  CHAT_TEACHER_TO_STUDENT_HELP: "When enabled, the teacher can start a conversation with a student during Game mode.",
  CHAT_STUDENT_TO_STUDENT_HELP: "When enabled, students can chat with each other during Game mode. The teacher can always read these conversations, and students are told so.",
  CHAT_STUDENT_TO_TEACHER_HELP: "When enabled, a student can start a conversation with the teacher during Game mode.",
  MANUALLY: "Manually",
  AUTOMATICALLY: "Automatically",
  AI_ASSESSMENT_MODE_HELP: "Manually: the teacher starts AI assessment with the Run AI Assessment button in Review Answers. Automatically: AI assessment runs automatically after submission.",
  RUN_AI_ASSESSMENT: "Run AI Assessment",
  ALL_AI_QUESTIONS_COMPLETED: "All AI-Assessed Questions have been completed.",
  AI_ASSESSMENT_QUEUED_OK: "AI assessment has started. {0} answer(s) queued.",
  AI_ASSESSMENT_QUEUED_FAIL: "Failed to start AI assessment.",
  NEW_APP_VERSION_REQUIRED: "This feature works only in EduVenture-AI app v1.5.0 or later.",
  VOICE_TO_TEXT: "Voice to Text",
  PREMIUM_FEATURE_VOICE_TO_TEXT: "Please upgrade your subscription to use voice to text feature",
  UPGRADE_TO_PREMIUM: "This feature is restricted by your current subscription plan. We recommend upgrading to unlock more features",
  AI_TEXT_TRANSCRIPTION: "AI Voice to Text",
  RE_RUN_VOICE_TO_TEXT: "Re-run Speech-to-Text",
  BACK_TO_AND_CHOOSE: "Back to choose",
  SUBSCRIPTION: "Subscription",
  SUBSCRIPTION_TAB: "Subscriptions",
  SUBSCRIPTION_KEYWORD_SEARCH: "Keyword Search",
  SUBSCRIPTION_KEYWORD_HINT: "Name / Remark",
  SUBSCRIPTION_SORT_CREATED: "Created Time",
  SUBSCRIPTION_SORT_NAME_ZH: "Chinese Name",
  SUBSCRIPTION_SORT_NAME_EN: "English Name",
  SUBSCRIPTION_SORT_DESC: "DESC",
  SUBSCRIPTION_SORT_ASC: "ASC",
  SUBSCRIPTION_SEARCHING: "Searching...",
  SUBSCRIPTION_NO_RESULT: "No subscriptions found",
  SUBSCRIPTION_FOUND_COUNT: "Found {0} subscription(s)",
  SUBSCRIPTION_LOCALE_BUTTON: "Set additional LOCALEs",
  SUBSCRIPTION_EXTRA_LOCALE_USAGE: "Assigned extra LOCALEs / maximum",
  SUBSCRIPTION_PRIVILEGE_BUTTON: "Privileges",
  SUBSCRIPTION_LOCALE_FAILED: "Failed to load subscription locales",
  SUBSCRIPTION_PRIVILEGE_FAILED: "Failed to load subscription privileges",
  SUBSCRIPTION_SEARCH_FAILED: "Subscription search failed",
  SUBSCRIPTION_NAME_ZH: "Name (Zh)",
  SUBSCRIPTION_NAME_EN: "Name (En)",
  SUBSCRIPTION_IS_TEMPLATE: "Is template",
  SUBSCRIPTION_DOUBLE_CLICK_EDIT: "Double-click to edit",
  SUBSCRIPTION_UPDATE_SUCCESS: "Subscription updated",
  SUBSCRIPTION_UPDATE_FAILED: "Failed to update subscription",
  SUBSCRIPTION_LOCALE_TITLE: "Extra LOCALE settings in subscription",
  SUBSCRIPTION_ASSIGNED_LOCALES: "Assigned LOCALES",
  SUBSCRIPTION_AVAILABLE_LOCALES: "Available LOCALES",
  SUBSCRIPTION_LOCALE_SEARCH_BY_USER: "User",
  SUBSCRIPTION_LOCALE_SEARCH_BY_SUBSCRIPTION: "Other subscription",
  SUBSCRIPTION_LOCALE_SEARCH_BY_KEYWORD: "Keyword",
  SUBSCRIPTION_LOCALE_USER_SEARCH_PLACEHOLDER: "Search username or display name",
  SUBSCRIPTION_LOCALE_SUBSCRIPTION_SEARCH_PLACEHOLDER: "Search subscription name (Chinese or English)",
  SUBSCRIPTION_LOCALE_SEARCH_PLACEHOLDER: "Search LOCALE name",
  SUBSCRIPTION_LOCALE_USER_SEARCH_PROMPT: "Search by username or display name",
  SUBSCRIPTION_LOCALE_SUBSCRIPTION_SEARCH_PROMPT: "Search another subscription by its Chinese or English name",
  SUBSCRIPTION_LOCALE_NO_USER_RESULT: "No matching users found",
  SUBSCRIPTION_LOCALE_NO_SUBSCRIPTION_RESULT: "No matching subscriptions found",
  SUBSCRIPTION_LOCALE_USER_FILTER: "User: {0}",
  SUBSCRIPTION_LOCALE_SUBSCRIPTION_FILTER: "Subscription: {0}",
  SUBSCRIPTION_LOCALE_SOURCE_SEARCH_FAILED: "Failed to search users or subscriptions",
  SUBSCRIPTION_LOCALE_SEARCH_PROMPT: "Search for LOCALES to assign",
  SUBSCRIPTION_LOCALE_NO_SEARCH_RESULT: "No available LOCALES found",
  SUBSCRIPTION_LOCALE_ASSIGN_SELECTED: "Assign selected LOCALES",
  SUBSCRIPTION_LOCALE_LIMIT_REACHED: "LOCALE limit reached",
  SUBSCRIPTION_LOCALE_SEARCH_FAILED: "Failed to search LOCALES",
  SUBSCRIPTION_NO_LOCALE: "No LOCALE",
  SUBSCRIPTION_PRIVILEGE_TITLE: "Subscription privileges",
  SUBSCRIPTION_PRIVILEGE_NAME: "Privilege Name",
  SUBSCRIPTION_NO_PRIVILEGE: "No privilege",
  PLAN_EXTRA_LOCALE_VALUE: "{0} extra LOCALE(s)",
  PLAN_EXTRA_LOCALE_ADMIN_HELP: "Maximum number of extra LOCALEs that can be assigned to this subscription.",
  // Extra Locale (預製教材範本) selection — teacher-facing dialog
  EXTRA_LOCALE_MENU: "Extra Locales",
  EXTRA_LOCALE_TAB: "Extra LOCALE",
  EXTRA_LOCALE_TAB_HELP: "The pre-made templates your school selected. View only — they cannot be edited or deleted.",
  EXTRA_LOCALE_TITLE: "EduVenture-AI®️ Pre-made Teaching Material Templates",
  EXTRA_LOCALE_HEADER_INTRO: "Schools subscribed to the 「{0}」 plan: please select {1} pre-made teaching material template(s).",
  EXTRA_LOCALE_HEADER_INTRO_NO_PLAN: "Please select {0} pre-made teaching material template(s).",
  EXTRA_LOCALE_NOTES_TITLE: "Notes:",
  EXTRA_LOCALE_NOTE_PARTIAL: "If you cannot settle on all the templates at this stage, pick your preferred ones first — the rest may be selected at any time within the service period.",
  EXTRA_LOCALE_NOTE_MANUAL: "After selecting your templates, teachers can click 「Extra LOCALE」 at the top of the home page, then click the 「PDF」 icon at the bottom of the LOCALE card to download the corresponding teacher reference manual.",
  EXTRA_LOCALE_NOTE_RESOURCES: "For the subject release schedule and template details, please visit ",
  EXTRA_LOCALE_NOTE_RESOURCES_SUFFIX: ".",
  EXTRA_LOCALE_RESOURCES_URL: "https://clst.fed.cuhk.edu.hk/evqef/resources/",
  EXTRA_LOCALE_CONTACT_TITLE: "If you have any questions about the above, please contact our colleagues at the centre:",
  EXTRA_LOCALE_CONTACT_1: "Ms. Pang: 3943 0425 (general enquiries)",
  EXTRA_LOCALE_CONTACT_3: "Mr. Yeung: 3943 0659 (EduVenture-AI®️ troubleshooting)",
  EXTRA_LOCALE_QUOTA_SUMMARY: "Selected {0} of {1}",
  EXTRA_LOCALE_REMAINING: "{0} slot(s) remaining",
  EXTRA_LOCALE_PERMANENT_WARNING: "Once a template is selected it cannot be changed. Please decide together with your school's subject teachers, based on your students' learning needs.",
  EXTRA_LOCALE_NOT_ELIGIBLE: "Your school's subscription plan does not include Extra Locale templates. Please contact the EduVenture team for enquiries.",
  EXTRA_LOCALE_SELECTION_TITLE: "Select pre-made teaching material templates",
  EXTRA_LOCALE_SELECTED_LIST: "Added LOCALEs",
  EXTRA_LOCALE_NONE_SELECTED: "No templates selected yet.",
  EXTRA_LOCALE_AVAILABLE_LIST: "Available LOCALEs",
  EXTRA_LOCALE_CATALOG_EMPTY: "No templates are available for selection at the moment.",
  EXTRA_LOCALE_SELECTED_BY: "Selected by",
  EXTRA_LOCALE_SELECTED_AT: "Date",
  EXTRA_LOCALE_ALREADY_SELECTED_ROW: "Selected",
  EXTRA_LOCALE_PENDING_ROW: "Ready to submit",
  EXTRA_LOCALE_ADD: "Add",
  EXTRA_LOCALE_SELECTED_TO_ADD: "{0} selected",
  EXTRA_LOCALE_REMOVE_PENDING: "Remove from added items",
  EXTRA_LOCALE_SUBMIT: "Submit selection",
  EXTRA_LOCALE_CONFIRM_TITLE: "Confirm template selection",
  EXTRA_LOCALE_CONFIRM_INTRO: "You are about to select the following {0} template(s). This cannot be changed or removed afterwards:",
  EXTRA_LOCALE_CONFIRM_SUBMIT: "Confirm (final)",
  EXTRA_LOCALE_SUBMIT_SUCCESS: "Template selection submitted.",
  EXTRA_LOCALE_SUBMIT_FAILED: "Failed to submit template selection",
  EXTRA_LOCALE_QUOTA_EXCEEDED: "The selection exceeds your plan's allowance ({0} used / limit {1}).",
  EXTRA_LOCALE_NOTHING_TO_ADD: "All of the requested templates have already been selected.",
  EXTRA_LOCALE_LOAD_FAILED: "Failed to load Extra Locale templates",
  // Extra Locale — admin management (platform admins, role >= 3)
  EXTRA_LOCALE_ADMIN_SECTION: "Extra Locales",
  EXTRA_LOCALE_ADMIN_TAB: "Manage Templates",
  EXTRA_LOCALE_ADMIN_HISTORY: "Selection History",
  EXTRA_LOCALE_ADMIN_HINT: "These are the pre-made templates every school can pick from. Turning off \"Available\" hides a template from the selection form; existing selection records are unaffected.",
  EXTRA_LOCALE_ADMIN_CREATE: "Add Template",
  EXTRA_LOCALE_ADMIN_EDIT: "Edit Template",
  EXTRA_LOCALE_ADMIN_DELETE: "Delete Template",
  EXTRA_LOCALE_ADMIN_DELETE_CONFIRM: "Delete template \"{0}\"? Schools' existing selection records will be kept.",
  EXTRA_LOCALE_ADMIN_DELETE_SELECTED_WARNING: "This template has been selected {0} time(s).",
  EXTRA_LOCALE_ADMIN_EMPTY: "No templates yet",
  EXTRA_LOCALE_NAME: "Name",
  EXTRA_LOCALE_CATEGORY: "Category",
  EXTRA_LOCALE_CATEGORY_HINT: "e.g. 小學 - 常識科（人文科及科學科）",
  EXTRA_LOCALE_REMARKS: "Remarks",
  EXTRA_LOCALE_EPACK_ID: "LOCALE id",
  EXTRA_LOCALE_EPACK_NAME: "LOCALE name",
  EXTRA_LOCALE_EPACK_PICKER: "LOCALE",
  EXTRA_LOCALE_EPACK_PICKER_HINT: "Type part of the LOCALE name, then choose from the list",
  EXTRA_LOCALE_EPACK_PICKER_PLACEHOLDER: "Search LOCALE name...",
  EXTRA_LOCALE_EPACK_SELECTED: "Selected",
  EXTRA_LOCALE_EPACK_NO_RESULTS: "No matching LOCALE",
  EXTRA_LOCALE_EPACK_REQUIRED: "Please pick a LOCALE from the list",
  EXTRA_LOCALE_EXPORT_CSV: "Export CSV",
  EXTRA_LOCALE_EXPORT_FAILED: "Export failed",
  EXTRA_LOCALE_EXPORT_FROM: "Export from",
  EXTRA_LOCALE_EXPORT_TO: "Export to",
  EXTRA_LOCALE_EXPORT_RANGE_INVERTED: "The end date cannot be before the start date.",
  EXTRA_LOCALE_EXPORT_RANGE_INVALID: "That is not a valid date — please pick one from the calendar.",
  EXTRA_LOCALE_EXPORT_EMPTY: "No selection records in the chosen date range.",
  EXTRA_LOCALE_EXPORT_TRUNCATED: "The server returns at most {0} records, so this date range may be incomplete. Narrow the range or add a keyword.",
  EXTRA_LOCALE_EPACK_DANGLING: "LOCALE deleted",
  EXTRA_LOCALE_CATEGORY_INDEX: "Category order",
  EXTRA_LOCALE_CATEGORY_INDEX_HINT: "Order of the category group in the selection form; use the same value for every template of a category",
  EXTRA_LOCALE_DISPLAY_INDEX_HINT: "Order of the template within its category",
  EXTRA_LOCALE_DISPLAY_INDEX: "Order",
  EXTRA_LOCALE_ENABLED: "Available",
  EXTRA_LOCALE_SELECTION_COUNT: "Selections",
  EXTRA_LOCALE_SCHOOL: "School",
  EXTRA_LOCALE_USER: "User",
  EXTRA_LOCALE_HISTORY_EMPTY: "No selection records",
  EXTRA_LOCALE_SEARCH_PLACEHOLDER: "Search template / school / user...",
  EXTRA_LOCALE_SAVE_FAILED: "Failed to save template",
  EXTRA_LOCALE_DELETE_FAILED: "Failed to delete template",

  // 教師參考手冊 — the per-template teacher reference manual (PDF). Admins
  // attach one on Manage Templates; a school reads it off its Extra LOCALE tab
  // AFTER selecting the template. This download is the route the selection form
  // spells out in EXTRA_LOCALE_NOTE_MANUAL — keep the two in step if the tab
  // name or the card icon ever changes.
  EXTRA_LOCALE_MANUAL: "Teacher reference manual (PDF)",
  EXTRA_LOCALE_MANUAL_COLUMN: "Manual",
  EXTRA_LOCALE_MANUAL_DOWNLOAD: "Download the teacher reference manual",
  EXTRA_LOCALE_MANUAL_DOWNLOAD_FAILED: "Could not download the teacher reference manual",
  // Appended to the LOCALE name when the browser saves the file, so the
  // download lands as "GS08 [TC] (26 27) 山頂 Teacher Reference Manual.pdf"
  // rather than under the blob's generated name.
  EXTRA_LOCALE_MANUAL_FILE_SUFFIX: "Teacher Reference Manual",
  EXTRA_LOCALE_MANUAL_UPLOAD: 'Upload the teacher reference manual',
  EXTRA_LOCALE_MANUAL_REPLACE: 'Replace the teacher reference manual',
  EXTRA_LOCALE_MANUAL_DELETE: 'Delete the teacher reference manual',
  // Names the real consequence: the template survives, the download does not.
  EXTRA_LOCALE_MANUAL_DELETE_CONFIRM: 'Delete the teacher reference manual for \"{0}\"? The template itself is unaffected.',
  EXTRA_LOCALE_MANUAL_DELETE_SELECTED_WARNING: 'The {0} school(s) that selected this template will no longer be able to download this PDF.',
  EXTRA_LOCALE_MANUAL_UPLOADED: 'Teacher reference manual uploaded',
  EXTRA_LOCALE_MANUAL_DELETED: 'Teacher reference manual deleted',
  EXTRA_LOCALE_MANUAL_UPLOAD_FAILED: 'Failed to upload the teacher reference manual',
  EXTRA_LOCALE_MANUAL_DELETE_FAILED: 'Failed to delete the teacher reference manual',
  EXTRA_LOCALE_MANUAL_NOT_PDF: 'The teacher reference manual must be a PDF file.',
  EXTRA_LOCALE_MANUAL_TOO_LARGE: 'That file is too large (limit {0}MB).',
  EXTRA_LOCALE_MANUAL_ADMIN_HELP: "PDF, up to 20MB. Schools that have selected this template can download it from their \"Extra LOCALE\" tab. It is not downloaded onto student devices.",

  // Scheduled Selection History mail (Extra Locales > Report Email). The times
  // below describe the ACA job, not anything this page controls: it runs at
  // 09:00 Hong Kong, sends yesterday every day, and adds the previous Mon-Sun
  // on Mondays. Keep the hint and the two switch labels in step with
  // selection_report_service if that schedule ever changes.
  EXTRA_LOCALE_REPORT_TAB: "Report Email",
  EXTRA_LOCALE_REPORT_SCHEDULE_HINT: "Every day at 09:00 (Hong Kong time) the previous day's selection records are emailed out; every Monday at 09:00 the previous week (Monday to Sunday) is emailed as well. Each message carries the same CSV the Selection History page exports.",
  EXTRA_LOCALE_REPORT_SMTP_MISSING: "The server has no SMTP account configured, so no mail will be sent even with recipients filled in. Please contact the system administrator.",
  EXTRA_LOCALE_REPORT_RECIPIENTS: "Recipient email addresses",
  EXTRA_LOCALE_REPORT_RECIPIENTS_HELP: "One address per line; commas and semicolons also work. Leave empty to stop sending.",
  EXTRA_LOCALE_REPORT_RECIPIENT_COUNT: "{0} recipient address(es) saved",
  EXTRA_LOCALE_REPORT_DAILY: "Send daily (the previous day's records)",
  EXTRA_LOCALE_REPORT_WEEKLY: "Send every Monday (the previous week's records)",
  EXTRA_LOCALE_REPORT_SEND_WHEN_EMPTY: "Send even when there are no records",
  EXTRA_LOCALE_REPORT_SEND_WHEN_EMPTY_HELP: "When off, no mail is sent for a period with no selections \u2014 an empty inbox then cannot be told apart from a failed send.",
  EXTRA_LOCALE_REPORT_SEND_DAILY_NOW: "Send daily report now",
  EXTRA_LOCALE_REPORT_SEND_WEEKLY_NOW: "Send weekly report now",
  EXTRA_LOCALE_REPORT_SEND_NOW_HELP: "\"Send now\" mails the saved recipient list over the same date range the schedule would use, as a test.",
  EXTRA_LOCALE_REPORT_SAVE_FIRST: "Please save the settings before sending a test message.",
  EXTRA_LOCALE_REPORT_SENT: "Sent {0} to {1} ({2} record(s))",
  EXTRA_LOCALE_REPORT_NO_RECIPIENTS: "No recipient address has been set.",
  EXTRA_LOCALE_REPORT_SAVED: "Report email settings saved",
  EXTRA_LOCALE_REPORT_LOAD_FAILED: "Failed to load report email settings",
  EXTRA_LOCALE_REPORT_SAVE_FAILED: "Failed to save report email settings",
  EXTRA_LOCALE_REPORT_SEND_FAILED: "Failed to send",

  // Dashboards section, below Extra Locales. Platform admins (role >= 3). Windows and what
  // each number counts live in ev_web_v2 platform_dashboard_service: Hong Kong
  // time, through the end of today, compared with the previous window of the
  // same length. Keep these notes in step with that service.
  DASHBOARD_SECTION: "Dashboards",
  DASHBOARD_TAB: "Dashboards",
  DASHBOARD_TITLE: "Dashboards",
  DASHBOARD_INTRO: "Platform-wide totals, in Hong Kong time.",
  DASHBOARD_DAY: "Today",
  DASHBOARD_DAYS_7: "Past 7 days",
  DASHBOARD_DAYS_30: "Past 30 days",
  DASHBOARD_REFRESH: "Refresh",
  DASHBOARD_RANGE: "{0}",
  DASHBOARD_PREVIOUS: "Previous period {0}",
  DASHBOARD_LOAD_FAILED: "Could not load the dashboard",
  DASHBOARD_LOGINS: "User logins",
  DASHBOARD_LOGINS_HINT: "Distinct accounts that signed in. Devices are not counted.",
  DASHBOARD_LOGINS_APP: "User logins (app)",
  DASHBOARD_LOGINS_APP_HINT: "Distinct accounts that signed in on the app, plus devices that entered a school key.",
  DASHBOARD_LOGINS_DEVICES: "Anonymous app use",
  DASHBOARD_LOGINS_DEVICES_HINT: "Devices that are not signed in, counted as distinct devices.",
  DASHBOARD_LOGINS_COMPOSER: "User logins (composer)",
  DASHBOARD_LOGINS_COMPOSER_HINT: "Distinct accounts that signed in on the composer.",
  DASHBOARD_UNIQUE_USERS: "{0} distinct accounts",
  DASHBOARD_NEW_USERS: "New users",
  DASHBOARD_NEW_USERS_HINT: "Accounts created in this period.",
  DASHBOARD_LOCALES_CREATED: "LOCALEs created",
  DASHBOARD_LOCALES_CREATED_HINT: "New LOCALEs. Duplicates are not included.",
  DASHBOARD_LOCALES_DELETED: "LOCALEs deleted",
  DASHBOARD_LOCALES_DELETED_HINT: "LOCALEs deleted in this period.",
  DASHBOARD_LOCALES_DUPLICATED: "LOCALEs duplicated",
  DASHBOARD_LOCALES_DUPLICATED_HINT: "LOCALEs made by duplicating another.",
  DASHBOARD_EXTRA_SELECTED: "Extra LOCALEs selected",
  DASHBOARD_EXTRA_SELECTED_HINT: "Templates schools selected.",
  DASHBOARD_MODELS: "3D models generated",
  DASHBOARD_MODELS_HINT: "Models that finished saving.",
  DASHBOARD_NOTES_TITLE: "How these numbers are counted",
  DASHBOARD_NOTE_WINDOW: "Today, the past 7 days and the past 30 days all run through the end of today. The past 7 days are today and the 6 days before it; the past 30 days are today and the 29 days before it. The change beside each total compares that window with the previous one of the same length: today against yesterday, the past 7 days against the 7 days before them, and the past 30 days against the 30 days before them.",
  DASHBOARD_NOTE_ACTIVITY: "Logins, new users and LOCALE deletions come from the activity log. Account logins are distinct accounts for the whole period, split into the app and the composer. The composer figure includes the previous composer. An account that signs in on both is counted in each. Anonymous app use counts devices that stayed signed out, by device id. A device that enters a school key is counted in User logins (app) instead. Someone, or one device, that signs in on several days counts once. The bars count distinct accounts or devices each day. New users are counted only from this release, because the user table has no created date. Deletions are counted from 2026-09-17.",
  DASHBOARD_NOTE_LOCALES: "Creates use the LOCALE's own created time and exclude duplicates. A create that was later deleted still counts when the activity log kept it. Duplicates use the duplication record, including clones deleted afterwards.",
  DASHBOARD_NOTE_REST: "Selected extra LOCALEs follow Selection History: one count per school and template, at the earliest selection. One pick on a shared plan counts once for each school on that plan. 3D models count only generations that finished saving.",
  VALUE: "Value",
  GROUP: "Group",
  LANG: "Language",
  SUBSCRIPTION_CREATE: "Create Subscription",
  SUBSCRIPTION_NAME_REQUIRED: "Chinese name is required",
  SUBSCRIPTION_NAME_EN_REQUIRED: "English name is required",
  SUBSCRIPTION_CREATE_SUCCESS: "Subscription created",
  SUBSCRIPTION_CREATE_FAILED: "Failed to create subscription",
  SUBSCRIPTION_DELETE: "Delete Subscription",
  SUBSCRIPTION_DELETE_CONFIRM: "Are you sure you want to delete this subscription?",
  SUBSCRIPTION_DELETE_SUCCESS: "Subscription deleted",
  SUBSCRIPTION_DELETE_FAILED: "Failed to delete subscription",
  SUBSCRIPTION_DELETE_BLOCKED: "This subscription is assigned to schools. Please delete those school assignments first.",
  SUBSCRIPTION_ASSIGNED_SCHOOLS: "Assigned schools",
  SUBSCRIPTION_COPY_PRIV_LABEL: "Copy Privilege from Subscription",
  SUBSCRIPTION_COPY_LOCALE_LABEL: "Also copy the source subscription's extra LOCALEs",
  SUBSCRIPTION_SOURCE_LABEL: "Source",
  SUBSCRIPTION_SOURCE_NOT_SELECTED: "Not selected",
  SUBSCRIPTION_SOURCE_PRIVILEGES: "Source subscription privileges",
  SUBSCRIPTION_SELECT_FROM_TEMPLATES: "Select from templates",
  SUBSCRIPTION_NO_TEMPLATES: "No subscription templates available",
  SUBSCRIPTION_PICKER_PLACEHOLDER: "Search subscription name...",
  SUBSCRIPTION_EPICKER_PLACEHOLDER: "Search epack by name",
  SUBSCRIPTION_ADD_EPICK: "Add LOCALE",
  SUBSCRIPTION_REMOVE_CONFIRM: "Remove this item?",
  SUBSCRIPTION_REMOVE_SELECTED: "Remove selected",
  SUBSCRIPTION_REMOVE_SELECTED_CONFIRM: "Remove {0} selected LOCALE(s)?",
  SUBSCRIPTION_REMOVE_SELECTED_FAILED: "Failed to remove {0} LOCALE(s)",
  DELETE: "Delete",
  RESET: "Reset",
  SCHOOL_SUBSCRIPTION_FILTER: "Filter schools by subscription",
  SCHOOL_ELAFP_FILTER_TOOLTIP: "Show only schools holding an eLAFP subscription",
  SCHOOL_MATCHED_SUBSCRIPTION: "Matched subscription",
  SCHOOL_LAST_SUBSCRIPTION_UPDATE: "Last subscription update",
  SCHOOL_EPACK_QUOTA: "ePack quota",
  SCHOOL_EPACK_QUOTA_NOT_ASSIGNED: "Not yet assigned",
  SCHOOL_SUBSCRIPTION_KEYWORD_NO_MATCH: "No subscription matches \"{0}\"",
  SCHOOL_SUBSCRIPTION_KEYWORD_PARTIAL: "{0} of {1} subscriptions failed to load; this list may be incomplete",
  SCHOOL_SUBSCRIPTION_KEYWORD_TRUNCATED: "Showing the first {0} of {1} schools — raise the result limit to see the rest",
  SCHOOL_SUBSCRIPTION_KEYWORD_CAPPED: "Subscription lookup hit its {0}-row cap; newer subscriptions may be missing",
  SCHOOL_INCLUDE_EXPIRED_LABEL: "Include expired",
  SCHOOL_INCLUDE_EXPIRED_TOOLTIP: "List schools whose grant has lapsed too; by default only unexpired subscriptions are shown",
  SCHOOL_RESULT_COUNT: "{0} schools",
  SCHOOL_RESULT_COUNT_TRUNCATED: "Showing {0} of {1} schools",
  SCHOOL_RESULT_COUNT_CAPPED: "Showing the first {0} schools — there may be more",
  SCHOOL_EXPORT_CSV: "Export CSV",
  SCHOOL_EXPORT_CSV_TOOLTIP: "Export every school matching the current filter as CSV",
  SCHOOL_EXPORT_DONE: "Exported {0} schools",
  SCHOOL_EXPORT_EMPTY: "Nothing to export",
  SCHOOL_EXPORT_SEARCHING: "The search is still running — try the export again in a moment.",
  SCHOOL_EXPORT_CAPPED: "The export stops at {0} schools and may be incomplete — narrow the filter",
  SCHOOL_EXPORT_FAILED: "Export failed",
  SCHOOL_SUBSCRIPTION_ACTION: "Subscription",
  SCHOOL_SUBSCRIPTION_DIALOG_TITLE: "School Subscriptions",
  SCHOOL_SUBSCRIPTION_ADD: "Add Subscription to School",
  SCHOOL_SUBSCRIPTION_CREATE: "Create Subscription",
  SCHOOL_SUBSCRIPTION_SEARCH_PLACEHOLDER: "Search subscription...",
  SCHOOL_SUBSCRIPTION_NONE: "No subscriptions yet",
  SCHOOL_SUBSCRIPTION_SELECT: "Please select a subscription",
  SCHOOL_SUBSCRIPTION_ADDED: "Subscription added",
  SCHOOL_SUBSCRIPTION_LOAD_FAILED: "Failed to load subscriptions",
  SCHOOL_SUBSCRIPTION_START: "Start Date",
  SCHOOL_SUBSCRIPTION_START_REQUIRED: "Please select a start date",
  SCHOOL_SUBSCRIPTION_DURATION: "Duration",
  SCHOOL_SUBSCRIPTION_HALF_YEAR: "Half year",
  SCHOOL_SUBSCRIPTION_ONE_YEAR: "1 year",
  SCHOOL_SUBSCRIPTION_TWO_YEARS: "2 years",
  SCHOOL_SUBSCRIPTION_THREE_YEARS: "3 years",
  SCHOOL_SUBSCRIPTION_EXPIRE: "Expire Date",
  SCHOOL_SUBSCRIPTION_STATUS: "Status",
  SCHOOL_SUBSCRIPTION_ACTIVE: "Active",
  SCHOOL_SUBSCRIPTION_EXPIRED: "Expired",
  SCHOOL_SUBSCRIPTION_UPDATE: "Edit",
  SCHOOL_SUBSCRIPTION_UPDATED: "Subscription record updated",
  SCHOOL_SUBSCRIPTION_UPDATE_FAILED: "Failed to update subscription record",
  SCHOOL_SUBSCRIPTION_DELETE: "Remove Subscription",
  SCHOOL_SUBSCRIPTION_DELETED: "Subscription removed",
  SCHOOL_SUBSCRIPTION_DELETE_FAILED: "Failed to remove subscription",
  SCHOOL_SUBSCRIPTION_DELETE_CONFIRM: "Are you sure you want to remove this subscription from the school?",
  MAX_SCORE: "Max Score",
  MAX_SCORE_HINT: "Set the maximum score a student can earn for this question.",
  NOT_GRADED: "Not Graded",
  MARKING_SCHEME: "Marking Scheme",
  AI_MARKING_SCHEME: "AI Auto-Assessment Marking Scheme",
  MARKING_SCHEME_INSTRUCTION: "To enable AI auto-assessment, please provide the Correct Answer. ‘Answer to Exclude’ and ‘Other Guidelines’ are optional fields that can help improve AI assessment accuracy.",
  MARKING_SCHEME_AI_HINT: "AI will assess student answers based on the Correct Answer and Other Guidelines. Use clear and specific wording to improve AI accuracy.",
  ANSWER_TO_EXCLUDE: "Answer to Exclude",
  OTHER_GUIDELINES: "Other Guidelines",
  SUBMIT_TO_AI: "Submit to AI",
  AI_ASSESSMENT_RESULT: "AI Assessment Result",
  OLD_PASSWORD_HELPER: "Your Original Password",
  NEW_PASSWORD_HELPER: "New password should contain letters and numbers",
  CONFIRM_PASSWORD_HELPER: "Re-enter the new password",
  DUPLICATION_RULE: "Duplication Rule",
  DUPLICATION_RULE_0: "Not allowed",
  DUPLICATION_RULE_1: "Allowed for users from the same school",
  DUPLICATION_RULE_2: "Allowed for users who can see this epack",
  DUPLICATION_RULE_3: "Allowed for anyone",
  DUPLICATION_RULE_HINT: "Set who can duplicate this resource",
  DUPLICATION_NOT_ALLOWED_HINT: "This is a duplicated epack and cannot be made public.",
  SCHOOL_ONLY_USE: "Own School Use Only",
  RESOURCE_LIBRARY: "Resource Library",
  DOWNLOAD_ANSWER: 'Download Answer',
  ANSWER_OF_LOCALE: '\'s Answer',
  TOTAL: 'Total',
  MY_LOCALE: "My LOCALE",
  SCHOOL_LOCALE_DUPLICATABLE: "Duplicatable School LOCALE",
  OTHER_LOCALE_DUPLICATABLE: "Other Duplicatable LOCALE",
  DUPLICATE: "Duplicate",
  CONFIRM_DUPLICATION: "Confirm Duplication",
  DUPLICATION_CONFIRM_MESSAGE: "You are about to duplicate the epack: {0}. This action will create a new, independent copy of the epack under your account. Please enter a name for the new epack below.",
  NEW_LOCALE_NAME: "New E-pack Name",
  DUPLICATION_NAME_HINT: "If left blank, the name will be the original name with a '(Copy)' suffix.",
  CONFIRM: "Confirm",
  LAST_UPDATE: "Last Update",
  DUPLICATABLE_LOCALE_TITLE: "LOCALE Available for Duplication",
  CREATE_NEW_LOCALE: "Create New Locale",
  LIST_VIEW: "List View",
  MAP_VIEW: "Map View",
  DUPLICATABLE_LIBRARY: "Duplicatable Library",
  AI_ASSESSMENT: "AI Assessment",
  PREMIUM_FEATURE_AI_ASSESSMENT: "This is a premium feature. Please upgrade your subscription to use AI assessment.",
  MARKING_SCHEME_MISSING: "Marking scheme is missing. Please set the marking scheme to use AI assessment.",
  SUBMISSION_SUMMARY: "Submission Summary for {0}",
  LOADING_SUMMARY: "Loading Summary...",
  LOADING_DATA: "Loading data...",
  PLEASE_PERFORM_AI_ASSESSMENT: "Please perform at least one AI assessment to view the summary.",
  VIEW_SUMMARY: "View AI Assessment Summary",
  LOAD_ANSWERS_FAILED: "Could not load this submission's answers. Please try again.",
  MARKING_SCHEME_AND_AI_ASSESSMENT: "Marking Scheme & AI Assessment",
  ASSESSMENT: "Assessment",
  CLICK_GET_AI_ASSESSMENT: "Click to get AI assessment",
  GET_AI_ASSESSMENT: "Get AI Assessment",
  RE_RUN_AI_ASSESSMENT: "Re-run AI Assessment",
  NO_ADDITIONAL_GUIDELINES: "No additional guidelines provided.",
  BATCH_ASSESSMENT: "Batch Assessment",
  AI_ASSESSABLE_QUESTIONS: "AI-Assessable Questions",
  ONGOING_AI_ASSESSABLE_QUESTIONS: "Remaining Questions",
  AI_ASSESSED_QUESTIONS: "AI-Assessed Questions",
  COMPLETION_PERCENTAGE: "Completion Rate",
  ASSESSMENT_COMPLETE: "Assessment Complete",
  ASSESSMENT_SUMMARY: "Assessment Summary",
  SCORE_DISTRIBUTION: "Score Distribution",
  // Mirrors ex_flutterv1's Map > "View Route History" (map.settings.view_route_history),
  // and runs the same filter pipeline, so the two views agree.
  VIEW_ROUTE_HISTORY: "View Route History",
  VIEW_ROUTE_HISTORY_TIP: "Show where this student moved during the field trip",
  NO_ROUTE_DATA: "This submission has no recorded movement",
  // Submission card counters: "Question: 2/10" and "Hotspot: 2/5", and the
  // hover tips that break each one down by hotspot.
  HOTSPOT: "Hotspot",
  MORE: "more",
  QUESTION_PROGRESS_TIP: "Questions answered, out of every question in this LOCALE",
  HOTSPOT_PROGRESS_TIP: "Hotspots with at least one answer, out of every hotspot in this LOCALE",
  // Assessment Summary chart view switcher.
  CHART_TAB_SCORE: "AI Score",
  BAR_UNIT_STUDENTS: "Each bar: number of students",
  BAR_UNIT_ANSWERS: "Each bar: number of answers",
  CHART_TAB_PAPER_SCORE: "Paper Score",
  CHART_TAB_BY_TOPIC: "By Content Type",
  PAPER_SCORE_MARKS: "Marks",
  NO_PAPER_SCORE_DATA: "No student has a marked answer yet",
  SCORE_MARKS_TIP: "Marks earned, out of the marks assigned to this LOCALE's questions",
  AI_PERCENT_TIP: "Average of this student's AI assessment percentages — a percentage, not marks out of a maximum",
  // Shown in place of the score bar when there is no score to draw.
  SCORE_NOT_SET: "Not marked",
  SCORE_NOT_SET_TIP: "No question in this LOCALE has marks assigned, so there is no score",
  SCORE_PENDING: "Not marked yet",
  SCORE_PENDING_TIP: "This LOCALE is marked, but none of this student's answers has a score yet",
  NO_STUDENTS: "No Students",
  SCORE_PERCENT: "Score (%)",
  AVERAGE_SCORE: "Average Score",
  REFRESH_DATA: "Refresh Data",
  PERFORMANCE_SUMMARY: "Performance Summary",
  BEST_PERFORMANCE_QUESTIONS: "Best Performance Questions",
  ANSWERS: "Answers",
  BEST_PERFORMANCE_STUDENTS: "Best Performance Students",
  WORST_PERFORMANCE_QUESTIONS: "Questions that need attention",
  WORST_PERFORMANCE_STUDENTS: "Students who need attention",
  ASSESSMENT_STATISTICS: "Assessment Statistics",
  STUDENT_COUNT: "Student Count",
  QUESTIONS_PER_WORKSHEET: "Questions per Worksheet",
  ESTIMATED_TIME: "Estimated Time",
  MINUTES: "minutes",
  START_NEW_AI_ASSESSMENT: "Start New AI Assessment",
  START_NEW_AI_ASSESSMENT_WARNING: "Starting a new assessment will clear all previous AI assessment data for this worksheet. Are you sure you want to proceed?",
  RE_EXECUTE_AI_ASSESSMENT: "Re-Execute AI Assessment",
  RE_EXECUTE_AI_ASSESSMENT_WARNING: "Re-executing the assessment will clear all previous AI assessment data for this worksheet. Are you sure you want to proceed?",
  CONFIRM_AI_ASSESSMENT: "Confirm AI Assessment",
  CONFIRM_SHARE_SUBMISSION: 'Confirm Share Submission',
  STUDENT_ANSWER: "Student's Answer",
  AI_SCORE: "AI Score",
  SHOW_ALL_ATTEMPTS: "Show All Attempts",
  NO_DATA: "No Data",
  COMPLETE_ASSESSMENT_FOR_DATA: "Please complete the AI assessment to view data.",
  NO_PERFORMANCE_DATA: "No performance data available.",
  NOT_STARTED: "Not Started",
  UPGRADE_TO_PREMIUM_FOR_AI: "AI assessment is a premium feature. Please upgrade your subscription",
  NO_ANSWER_ASSESSMENT: "No answers to assess.",
  PREMIUM_FEATURE_EXPORT_ANSWERS: "Exporting answers is a premium feature. Please upgrade your subscription",
  FIELD_TRIP_DATE: "Field Trip Date",
  SUMMARY: "View AI Summary",
  VIEW_CLASS_SUMMARY: "View class AI assessment report",
  INDIVIDUAL_STUDENT_SUBMISSIONS: "Individual Student Submissions",
  ASSESSMENT_IN_PROGRESS: "Assessment in Progress",
  RESUME_AI_ASSESSMENT: "Resume AI Assessment",
  RESUME_AI_ASSESSMENT_WARNING: "An AI assessment is already in progress. Would you like to resume it?",
  TIME_ESTIMATED: "Estimated Time:",
  DO_NOT_CLOSE: "Please do not close this window while the assessment is in progress.",
  ASSESSMENT_PROGRESS: "Assessment Progress",
  TOTAL_ANSWERS: "Total Answers",
  TOTAL_SUBMISSIONS: "Total Submissions",
  COMPLETED_SUCCESSFULLY: "Completed",
  FAILED: "Failed",
  PENDING: "Pending",
  SAFE_TO_CLOSE: "Assessment complete. It is now safe to close this window.",
  NO_QUESTIONS_FOR_AI_ASSESSMENT: "There are no questions in this submission that are suitable for AI assessment.",
  AI_ASSESSMENT_STATISTICS: "AI Assessment Statistics",
  ASSESSMENT_STATISTICS: "Assessment Statistics",
  OVERALL_ASSESSMENT_STATISTICS: "Overall Assessment Statistics",
  VIEW_CLASS_OVERALL_SUMMARY: "View class assessment report",
  SUBMISSION_BY: 'Submission by:',
  SUBMITTED_ON: 'Submitted on:',
  VIEW_PUBLIC_LOCALE: "View Public LOCALE",
  LOCALE_OF_MY_SCHOOL: "LOCALE of My School",
  LOCALE_OF_MY_SCHOOL_1: "LOCALE Created by My School",
  LOCALE_ASSESSMENT: "LOCALE Assessment",
  LOCALE_ASSESSMENT_1: "LOCALEs Used by My School",
  LOCALE_ASSESSMENT_HELP: "LOCALEs for which students at your school have submitted answers.",
  KLA: "KLA",
  ORDER_BY: "Order By",
  ORDER_MODE: "Order Mode",
  ORDER_BY_TIME_CREATED: "Time Created",
  ORDER_BY_TIME_MODIFIED: "Time Modified",
  ORDER_BY_EPACK_NAME: "Name",
  ASCENDING: "Ascending",
  DESCENDING: "Descending",
  HOTSPOT_VIEWER: "Hotspot Viewer",
  LOCALE_COLOR_REMINDER: "The color setting is to make the field trip easier to distinguish on the map and is not related to the content of the investigation.",
  SHAREABLE_PUBLIC_MODE_DESC: "Public mode: Devices from other schools can also see this field trip",
  SHAREABLE_SCHOOL_MODE_DESC: "School mode: Only devices from this school (with School Key entered in App) can see this field trip",
  SHAREABLE_HINT: "When set to Public, devices from other schools can also see this field trip; when set to School Only, only devices with the School Key can see it",
  PUBLISH_MODE_DESC: "Published mode: App can see and search this field trip",
  UNPUBLISH_MODE_DESC: "Not published: App cannot see this field trip map",
  PUBLISH_HINT: "The field trip must be published to appear in the App",
  PUBLISHING_AND_SHARING_SETTINGS: "Publishing and Sharing Settings",
  SUBSCRIPTION_DETAILS: "Subscription Details",
  PLAN: "Plan",
  SUBSCRIPTION_PERIOD: "Subscription Period",
  CLOSE: "Close",
  STORAGE_LIMIT_REACHED: "Storage Limit Reached",
  STORAGE_LIMIT_MESSAGE: "Your school storage is up to the limit. Please manage or upgrade your subscription.",
  OPEN_SUBSCRIPTION_PAGE: "Open Subscription Page",
  LOCALE_LIMIT_REACHED: "Locale Limit Reached",
  LOCALE_LIMIT_MESSAGE: "You have reached the maximum number of locales allowed under your subscription.",
  LOCALE_EDIT_BLOCKED_TITLE: "Editing Unavailable",
  LOCALE_EDIT_BLOCKED_MESSAGE: "Your school has no subscription in force, so existing LOCALEs can no longer be edited. Viewing them and retrieving student answers are not affected.",
  LOCALE_EDIT_BLOCKED_TOOLTIP: "No subscription in force \u2014 editing unavailable",
  LOCALE_CREATE_BLOCKED_TITLE: "Cannot Create LOCALE",
  LOCALE_CREATE_BLOCKED_MESSAGE: "Your school has no subscription in force, so its LOCALE allowance is 0 and no new LOCALE can be created. Existing LOCALEs and student answers remain available.",
  // Locale quota reminders — shown only to eLAFP Basic schools; see
  // tools/localeQuotaNotice.js for why the audience is scoped that way, and
  // docs/locale-subscription-quota.md for why deleting refunds nothing.
  LOCALE_QUOTA_DEDUCT_CREATE_NOTICE: "Note: creating this LOCALE will use up 1 unit of your school's LOCALE quota.",
  LOCALE_QUOTA_DEDUCT_DUPLICATE_NOTICE: "Note: duplicating this LOCALE will use up 1 unit of your school's LOCALE quota.",
  LOCALE_QUOTA_NO_REFUND_NOTICE: "Note: deleting a LOCALE does NOT return the quota unit that was used to create it.",
  // Numbered twins of the two above. Used ONLY when the get_epack_quota
  // balance is known AND the server would really charge this caller; the
  // numberless keys stay the fallback, so an unknown quota loses the figure
  // rather than the sentence. {0} = balance now, {1} = balance after.
  LOCALE_QUOTA_DEDUCT_CREATE_NOTICE_WITH_QUOTA: "Note: creating this LOCALE will use up 1 unit of your school's LOCALE quota (from {0} to {1}).",
  LOCALE_QUOTA_DEDUCT_DUPLICATE_NOTICE_WITH_QUOTA: "Note: duplicating this LOCALE will use up 1 unit of your school's LOCALE quota (from {0} to {1}).",
  DUPLICATE_NOT_ALLOWED_TITLE: "Duplication Not Allowed",
  DUPLICATE_NOT_ALLOWED_MESSAGE: "Duplicating resources is not allowed under your current subscription.",
  // Shown when the server refuses a locale write — the map is in
  // tools/serverErrorKey.js. An unmapped server detail is logged to the
  // console only and the flow's own generic sentence is shown instead; the
  // raw English detail from the API must never reach the user.
  DUPLICATE_FAILED: "Duplication failed.",
  DUPLICATE_SUCCESS: "Successfully duplicated as LOCALE ID: {0}.",
  DUPLICATE_SOURCE_UNAVAILABLE_MESSAGE: "This LOCALE cannot be duplicated: its owner has not allowed duplication, or it no longer exists. Please refresh the resource library.",
  LOCALE_GONE_MESSAGE: "This LOCALE no longer exists \u2014 it may already have been deleted. Please refresh the list.",
  LOCALE_CREATED_COVER_LINK_FAILED: "The LOCALE was created, but its cover image could not be linked to it.",
  LOCALE_QUOTA_CHECK_FAILED: "Could not check the LOCALE quota. Please try again.",
  RESOURCE_LIBRARY_LOAD_FAILED: "Failed to load the resource library. Please try again.",
  SERVER_REJECTED_INPUT: "Some fields could not be saved. Please check the name and description (emoji are not supported).",
  SERVER_BUSY_RETRY: "The server is busy. Please try again in a moment.",
  NETWORK_ERROR: "Could not reach the server. Check your connection and try again.",
  // EDConnect related
  // Renamed per SSO spec 2026-08-19 — spec-literal, so the same string in BOTH
  // locales. Written with 教 (not the 敎 variant the rename first carried), to
  // match EDCITY_UNLINKED_TITLE — the brand must read one way across the app.
  // The dialog behind it still links EdCity, Google and Apple.
  EDCONNECT_BINDING: '教育城EdConnect',
  // --- Provider linking (Google/Apple) + composer SSO -----------------------
  GOOGLE_LOGIN_HINT: 'Teachers: sign in with your password first and link Google under Account Binding.',
  GOOGLE_LOGIN_REFUSED: 'This Google account is not linked to a teacher account. Sign in with your password, then link it under Account Binding.',
  LOGIN_WITH_APPLE: 'Sign in with Apple',
  APPLE_LOGIN_REFUSED: 'This Apple account is not linked to a teacher account. Sign in with your password, then link it under Account Binding.',
  LINKED_SIGNIN_METHODS: 'Linked sign-in methods',
  LINK_PASSWORD_LABEL: 'Composer password',
  LINK_PASSWORD_HINT: 'Confirm your composer password, then choose the account to link. Once linked, you can sign in with it.',
  LINK_PASSWORD_REQUIRED: 'Password confirmation failed — check your password and try again.',
  // Distinct from the line above on purpose: nothing was checked and nothing
  // failed, the box is simply empty. Telling someone their password was wrong
  // when they never typed one sends them off to reset a password that is fine.
  LINK_PASSWORD_NEEDED: 'Enter your composer password above to confirm it is you, then try again.',
  LINK_GOOGLE_DONE: 'Google account linked',
  LINK_GOOGLE_CONFLICT: 'That Google account is already linked to a different user.',
  LINK_GOOGLE_FAILED: 'Could not link the Google account. Please try again.',
  LINK_WITH_APPLE: 'Link Apple account',
  LINK_APPLE_DONE: 'Apple account linked',
  LINK_APPLE_CONFLICT: 'That Apple account is already linked to a different user.',
  LINK_APPLE_FAILED: 'Could not link the Apple account. Please try again.',
  EDCONNECT_BIND_ALREADY_OTHER: 'This EdCity account is already linked to another user account.',
  // The OPPOSITE direction from the line above, and they must never be swapped.
  // That one says the EdCity account is taken by somebody else — a dead end the
  // user cannot resolve alone. This one says their OWN account is already
  // spoken for, which they can fix from this very dialog, so the sentence has
  // to carry the fix; without it they just see an error with no way out.
  EDCONNECT_BIND_ACCOUNT_HAS_ONE: 'This user account is already linked to an EdCity account. Each user account can be linked to one EdCity account — remove the existing link first if you want to link a different one.',
  // Replaces the "add account" button once a link exists. Not an error — the
  // ordinary explanation of why there is nothing to click.
  EDCONNECT_ONE_ACCOUNT_ONLY: 'Each user account can be linked to one EdCity account. To link a different one, remove the link above first.',
  EDCONNECT_BIND_SCHOOL_MISMATCH: 'This EdCity account belongs to a different school, so it cannot be linked to this user account.',
  // The conflicting link's owner is an account that was CREATED from this
  // EdCity identity (auto-provisioned). More than "already linked": the user
  // needs to know that created account's data stays where it is.
  EDCITY_CREATED_ACCOUNT_NO_MIGRATE: 'This EdCity account was previously used to create its own account. That account\'s data cannot be migrated to this user account.',
  // --- Unlinked-EdCity choice dialog (?edconnect=2) -------------------------
  // The dialog is titled with the product name rather than with the problem —
  // spec-literal, so it is the same string in BOTH locales, byte-identical to
  // EDCONNECT_BINDING above. The "not linked yet" explanation it replaced now
  // lives in EDCITY_CHOOSE_PROMPT, the first line of the body.
  EDCITY_UNLINKED_TITLE: '教育城EdConnect',
  // Opening line of the CHOICE screen, which now carries the two offers and
  // nothing else — with no credential fields on it, it has to say why it is
  // asking before it asks.
  EDCITY_CHOOSE_PROMPT: 'This EdCity account is not linked to an EduVenture-AI account yet. Choose how you would like to continue.',
  // Spec-literal reminder sentence (SSO spec 2026-08-19), shown when the
  // EdCity school IS onboarded — the two locales must carry the same meaning.
  // It now sits above the username/password fields on the second screen, once
  // the user has picked "link existing account".
  EDCITY_LINK_REMINDER: 'If you already have a username/email account, you can log in with that account and then link it to your EdCity account.',
  EDCITY_LOGIN_AND_LINK: 'Link existing EduVenture-AI account',
  // The tips under the two choice buttons. Each one names the user it is for,
  // because the labels alone stopped being self-explanatory the moment the
  // credential fields left the first screen.
  EDCITY_LOGIN_AND_LINK_HINT: 'Choose this if you already have an EduVenture-AI username/email account. Sign in with it once, and it will be linked to your EdCity account.',
  EDCITY_CREATE_ACCOUNT: 'Create new account',
  EDCITY_CREATE_ACCOUNT_HINT: 'Choose this if you do not have an EduVenture-AI account yet. A new account will be created and linked to your EdCity account.',
  // Shown before provisioning. It states only what is about to happen: the
  // title already says "Create new account" and the buttons already say
  // confirm/cancel, so neither the premise nor a "Continue?" needs repeating —
  // the identity being created is appended to this text by the dialog.
  EDCITY_CREATE_CONFIRM: 'A new EduVenture-AI account will be created for this EdCity account.',
  EDCITY_SCHOOL_UNKNOWN: 'The school of your EdCity account has not subscribed to EduVenture-AI, so this account cannot be used to sign in. Please contact the responsible staff at your school to arrange an EduVenture-AI subscription, or sign in with your username/email and password.',
  EDCITY_PENDING_EXPIRED: 'This EdCity sign-in attempt has expired. Please sign in with EdCity again.',
  // Wrong password on the "link existing account" screen. LoginPage.jsx:85 still passes
  // this same sentence as an English literal; the EdCity dialog cannot, because
  // a first-time EdCity user reaching it has just read two screens of their own
  // locale and is the reader most likely to mistype a password they rarely use.
  LOGIN_INCORRECT: 'Username / Password Incorrect',
  // Refused third-party sign-in, shown on the login card until dismissed.
  SSO_REFUSED_TITLE: 'Could not sign you in',
  // One sentence, addressed to the student. A learner reaches this refusal
  // whether or not the EdCity identity is already linked. An unlinked teacher
  // still gets a pending ticket and the "link existing / create account"
  // dialog (?edconnect=2). The teacher-side linking instructions were noise
  // for a student, and the three-line block buried the one line that was theirs.
  // Mirrors the tc copy, including the product naming ("EduVenture-AI
  // Composer", "EduVenture-AI app") — the two must not drift, or the same
  // refusal names two different products depending on locale.
  SSO_REFUSED_NOT_LINKED: 'EduVenture-AI Composer is a teacher tool — please use the EduVenture-AI app instead.',
  SSO_REFUSED_CANCELLED: 'Sign-in was cancelled before it finished. You can try again, or sign in with your username and password below.',
  SSO_REFUSED_UPSTREAM: 'Could not reach the sign-in provider. Please try again in a moment, or sign in with your username and password below.',
  LINK_REMOVE: 'Remove sign-in method',
  LINK_REMOVED: 'Sign-in method removed',
  LINK_INACTIVE: 'Unlinked — signing in with it again will re-link it',
  // Subscription status labels
  SUPPORTED: 'Supported',
  NOT_SUPPORTED: 'Not Supported',
  // MUI Button uppercases its label by default, so the button that renders this
  // sets textTransform: 'none' — otherwise the provider name reads "EDCONNECT".
  EDCONNECT_BIND_ACCOUNT: 'Bind EdConnect Account',
  // The line above the button on the empty state. It used to be an English
  // literal in the JSX, which every teacher on the default (tc) locale read
  // untranslated.
  EDCONNECT_BIND_HINT: 'Link your EdCity EdConnect account to sign in to EduVenture-AI with it. Each user account can be linked to one EdCity account.',
  // Shown while the sign-in is running in its own window. It names the window
  // on purpose: one that opens behind the browser or on a second monitor is
  // otherwise indistinguishable from a button that did nothing.
  EDCONNECT_BIND_WAITING: 'The EdCity EdConnect sign-in has opened in a new window. This page updates as soon as it is done.',
  EDCONNECT_LOADING_ACCOUNTS: 'Loading EdConnect accounts…',
  EDCONNECT_UNBIND_ACCOUNT: 'Remove Binding',
  EDCONNECT_ACCOUNT_LINKED: 'EDConnect account is linked',
  EDCONNECT_ACCOUNT_NOT_LINKED: 'No EDConnect account linked',
  EDCONNECT_BIND_SUCCESS: 'EDConnect account bound successfully',
  EDCONNECT_UNBIND_SUCCESS: 'EDConnect account unbound successfully',
  EDCONNECT_BIND_FAILED: 'Failed to bind EDConnect account',
  EDCONNECT_UNBIND_FAILED: 'Failed to unbind EDConnect account',
  EDCONNECT_LINKED_ACCOUNT: 'Linked Account:',
  EDCONNECT_ADD_ACCOUNT: 'Add EDConnect Account',
  EDCONNECT_CONFIRM_REMOVE: 'Are you sure you want to remove this EDConnect account binding? Once removed, you can link a different EdCity account.',
  LOGIN_WITH_EDCONNECT: 'Login with EdConnect',
  CONTINUE_WITH_EDCONNECT: 'Continue with EdConnect',
  EDCONNECT_SANDBOX_NOTE: 'Sandbox account',
  THIRD_PARTY_OR: 'or',
  THIRD_APRTY_NO_LINKED: 'No user is linked to this third-party account. Please complete account binding first.',
  THIRD_APRTY_LOGIN_FAILED: 'Third-party login failed. Please try again.',
  DATE_RANGE: "Date Range",
  FROM: "From",
  TO: "To",
  
  // NPC Avatar Content Type
  NPC_AVATAR: "NPC Avatar",
  NPC_AVATAR_DESCRIPTION: "Interactive NPC with AI conversation",
  NPC_NAME: "NPC Name",
  NPC_AVATAR_SELECT: "Avatar",
  NPC_VOICE_GENDER: "Voice Gender",
  NPC_LANGUAGE: "Language",
  NPC_TIME_ALLOWED: "Time Allowed",
  NPC_PERSONALITY: "Personality Type",
  NPC_BACKGROUND_INFO: "NPC Background & Knowledge",
  NPC_STUDENT_MISSION: "Student Mission / Marking Scheme",
  // NPC UI Section Headers
  NPC_BASIC_CONFIG: "Basic Configuration",
  NPC_VOICE_LANGUAGE_CONFIG: "Voice & Language Settings",
  NPC_PERSONALITY_CONFIG: "Personality Configuration",
  VOICE_MALE: "Male",
  VOICE_FEMALE: "Female",
  LANGUAGE_CHINESE: "Hong Kong (Cantonese)",
  LANGUAGE_MANDARIN: "Mandarin",
  LANGUAGE_ENGLISH: "English",
  TIME_2_MIN: "2 minutes",
  TIME_5_MIN: "5 minutes",
  TIME_10_MIN: "10 minutes",
  PLEASE_SELECT: "Please select",
  OPTIONAL: "Optional",
  CHARACTERS: "characters",
  REQUIRED: "Required",
  
  // NPC Validation Messages
  NPC_NAME_NOT_FILLED: "NPC name is required",
  NPC_AVATAR_NOT_FILLED: "NPC avatar selection is required",
  NPC_VOICE_GENDER_NOT_FILLED: "Voice gender is required",
  NPC_LANGUAGE_NOT_FILLED: "Language selection is required",
  NPC_PERSONALITY_NOT_FILLED: "NPC personality type is required",
  NPC_BACKGROUND_INFO_NOT_FILLED: "NPC background information is required",
  NPC_STUDENT_MISSION_NOT_FILLED: "Student Mission / Marking Scheme is required",
  // NPC per-locale quota
  NPC_QUOTA_LABEL: "NPC quota used in this locale",
  NPC_QUOTA_TOOLTIP: "{0} NPC(s) created in this locale; the limit is {1}.",
  NPC_LIMIT_REACHED_TITLE: "NPC limit reached",
  NPC_LIMIT_REACHED_MESSAGE: "You have reached the maximum number of NPCs for this locale ({0}/{1}). Please delete an existing NPC before creating a new one.",
  COPIED_TO_CLIPBOARD: 'Copied to clipboard',
  COPY: 'Copy',

  // Storage Info
  STORAGE_INFO: 'Storage Info',
  MY_STORAGE: 'My Storage',
  SCHOOL_STORAGE: 'School Storage',
  FILE_COUNT: 'Files',
  TOTAL_SIZE: 'Total Size',
  EPACK_NAME: 'Locale Name',
  USER_NAME: 'User',
  USER_LOGIN_NAME: 'Username',
  LOCALE_EPACK_COUNT: 'Locale Count',
  SCHOOL_NAME: 'School',
  MAX_STORAGE: 'Storage Limit',
  STORAGE_USAGE: 'Storage Usage',
  STORAGE_LIMIT_WARNING: 'You cannot create new LOCALEs because your storage limit has been reached. Please contact apply@ev-cuhk.net to upgrade your current plan.',
  NO_FILES: 'No files',

  // Keys that were referenced with a `|| 'fallback'` but never defined, so they
  // had no translation at all (see the Localization proxy in Localization.jsx).
  ADD: 'Add',
  USER: 'User',
  ASSISTANT: 'Assistant',
  CREATE_FAILED: 'Creation failed',
  MAP_LOAD_FAILED: 'Map failed to load',
  MAP_LOAD_FAILED_REMINDER: 'Please reload the page or try another browser/device. If the problem persists, contact support.',
  NO_DATE_SELECTED: 'No date selected',
  REFRESHING: 'Refreshing...',
  RESUME_AI_ASSESSMENT_RESULT: 'Resume Assessment Complete: {0} out of {1} answers processed ({2} failed)',
  SESSION_EXPIRED: 'Session expired, please sign in again.',
  EDCITY_LOGIN_SECTION: 'EdCity Login',
  EDCITY_SCRN_TAB: 'EdCity School ID Mapping',
  EDCITY_SCRN_CODE: 'SCRN',
  EDCITY_SCRN_SCHOOL_NAME: 'School Name (EdCity)',
  EDCITY_SCRN_OUR_SCHOOL_ID: 'School ID',
  EDCITY_SCRN_OUR_SCHOOL_NAME: 'School Name',
  EDCITY_SCRN_OUR_SCHOOL_NAME_ENG: 'School English Name',
  EDCITY_SCRN_CREATED: 'Created',
  EDCITY_SCRN_NOT_MAPPED: 'Not mapped',
  EDCITY_SCRN_CONNECT: 'Connect with school',
  EDCITY_SCRN_DISCONNECT: 'Clear connection',
  EDCITY_SCRN_REMOVE: 'Remove',
  EDCITY_SCRN_CREATE: 'Create Mapping',
  EDCITY_SCRN_FILTER_ALL: 'All records',
  EDCITY_SCRN_FILTER_MAPPED: 'Mapped only',
  EDCITY_SCRN_FILTER_UNMAPPED: 'Not mapped only',
  EDCITY_SCRN_SEARCH_PLACEHOLDER: 'Search SCRN or school name...',
  EDCITY_SCRN_PICK_SCHOOL: 'Select a school in our database',
  EDCITY_SCRN_PICK_SCHOOL_OPTIONAL: 'Leave empty to connect later',
  EDCITY_SCRN_CODE_HINT: 'EDB school registration number, exactly 12 digits',
  EDCITY_SCRN_CREATE_OK: 'Mapping created',
  EDCITY_SCRN_CREATE_FAILED: 'Failed to create mapping',
  EDCITY_SCRN_CONNECT_OK: 'School connected',
  EDCITY_SCRN_DISCONNECT_OK: 'Connection cleared',
  EDCITY_SCRN_UPDATE_FAILED: 'Failed to update mapping',
  EDCITY_SCRN_REMOVE_OK: 'Mapping removed',
  EDCITY_SCRN_REMOVE_FAILED: 'Failed to remove mapping',
  EDCITY_SCRN_REMOVE_CONFIRM: 'Remove this EdCity mapping record?',
  EDCITY_SCRN_NO_RESULT: 'No mapping records found',
  EDCITY_SCRN_VIEW_IN_SCHOOL_LIST: 'View in School List',
  EDCITY_SCRN_LOAD_FAILED: 'Failed to load mapping list',
  // EdCity Login > Subscription Binding + Import Mapping Excel
  SUBSCRIPTION_BINDING_TAB: 'Subscription Binding',
  SUBSCRIPTION_BINDING_DESC: 'Which subscription template each plan type is cloned from by "Import Mapping Excel", and how the new subscriptions are named. Placeholders: {school} Chinese school name, {school_en} English school name, {plan} plan type (體驗版/基本版/優越版), {plan_en} plan type in English.',
  SUBSCRIPTION_BINDING_READONLY: 'Only platform administrators can change subscription bindings.',
  SUBSCRIPTION_BINDING_PLAN: 'Plan type',
  SUBSCRIPTION_BINDING_TEMPLATE: 'Subscription template',
  SUBSCRIPTION_BINDING_PATTERN: 'New subscription name pattern',
  SUBSCRIPTION_BINDING_PICK_TEMPLATE: 'Select a template',
  SUBSCRIPTION_BINDING_UNBOUND: 'Not bound: CSV rows marking this plan will be rejected',
  SUBSCRIPTION_BINDING_MISSING: 'Subscription no longer exists',
  SUBSCRIPTION_BINDING_PREVIEW: 'e.g. ',
  SUBSCRIPTION_BINDING_SAMPLE_SCHOOL: 'XXX中學',
  SUBSCRIPTION_BINDING_SAMPLE_SCHOOL_EN: 'XXX Secondary School',
  SUBSCRIPTION_BINDING_PATTERN_HINT: 'The name pattern must contain {school} or {school_en}',
  SUBSCRIPTION_BINDING_RELOAD: 'Reload',
  SUBSCRIPTION_BINDING_SAVED: 'Subscription bindings saved',
  SUBSCRIPTION_BINDING_SAVE_FAILED: 'Failed to save subscription bindings',
  SUBSCRIPTION_BINDING_LOAD_FAILED: 'Failed to load subscription bindings',
  SUBSCRIPTION_BINDING_DATES_TITLE: 'School subscription period',
  SUBSCRIPTION_BINDING_DATES_DESC: 'Every subscription created by the CSV import is granted with this start and end date. While unset, the import can only map SCRNs, not create subscriptions.',
  SUBSCRIPTION_BINDING_DATES_UNSET: 'Not set: the import cannot create subscriptions',
  SUBSCRIPTION_BINDING_DATES_BOTH: 'Fill in both the start and end date, or leave both blank',
  SUBSCRIPTION_BINDING_DATES_ORDER: 'The end date cannot be before the start date',
  EDCITY_IMPORT_DATES: 'Subscription period: {0} to {1} (set on the Subscription Binding page)',
  EDCITY_IMPORT_DATES_UNSET: 'No subscription period is set. Set the start and end date on the Subscription Binding page first.',
  EDCITY_IMPORT_SCRN_EXCEL: 'Excel turned this SCRN into scientific notation (e.g. 1E+11) and the digits are lost. Format the SCRN column as Text in Excel, re-enter the 12 digits and save the CSV again',
  EDCITY_IMPORT_HELP_EXCEL: 'Use the Excel template below: its SCRN column is pre-formatted as Text, so 12-digit codes are not turned into 1E+11.',
  EDCITY_IMPORT_BUTTON: 'Import Mapping Excel',
  EDCITY_IMPORT_TITLE: 'Import Mapping Excel',
  EDCITY_IMPORT_DOWNLOAD_TEMPLATE: 'Download Excel Template',
  EDCITY_IMPORT_DOWNLOAD_TEMPLATE_TOOLTIP: 'Download a blank Excel template (SCRN column pre-formatted as Text)',
  EDCITY_IMPORT_UPLOAD: 'Upload Excel file',
  EDCITY_IMPORT_HELP_1: 'Upload an Excel file (.xlsx) to map many schools\' EdCity SCRNs at once and, where marked, create and assign subscriptions for each school. The first row must be the column headers:',
  EDCITY_IMPORT_HELP_REQUIRED: 'Required columns (every row):',
  EDCITY_IMPORT_HELP_2: 'At most {0} rows per file. After upload the server validates every row and asks the AI whether the EdCity school name matches our school record; doubtful schools are flagged for you to decide. Nothing is written until you confirm. Subscriptions are created from the templates configured on the Subscription Binding page.',
  EDCITY_IMPORT_VALIDATING: 'Validating and checking school names with AI, please wait...',
  EDCITY_IMPORT_FAILED: 'Excel import failed',
  EDCITY_IMPORT_EXCEL_ONLY: 'Please upload an Excel file (.xlsx); download the Excel template first',
  EDCITY_IMPORT_NOTHING_SELECTED: 'No school selected',
  EDCITY_IMPORT_AI_ERROR: 'The AI check did not complete: {0}. Unchecked schools are flagged for manual review.',
  EDCITY_IMPORT_SELECT_CONFIRMED: 'Select AI matches only',
  EDCITY_IMPORT_SELECT_ALL_VALID: 'Select all importable',
  EDCITY_IMPORT_CONFIRM: 'Import {0} school(s) (create {1} subscription(s))',
  EDCITY_IMPORT_DONE_TOAST: 'Imported {0} school(s), created {1} subscription(s)',
  EDCITY_IMPORT_RESULT_TITLE: 'Imported {0} school(s)',
  EDCITY_IMPORT_COL_PICK: 'Import',
  EDCITY_IMPORT_COL_PLANS: 'Subscriptions',
  EDCITY_IMPORT_COL_AI: 'AI check',
  EDCITY_IMPORT_COL_STATUS: 'Status',
  EDCITY_IMPORT_MAP_CREATE: 'New mapping',
  EDCITY_IMPORT_MAP_CONNECT: 'Connect existing SCRN',
  EDCITY_IMPORT_MAP_KEEP: 'Already mapped',
  EDCITY_IMPORT_ROW_DONE: 'Imported',
  EDCITY_IMPORT_REUSED: '(reused existing subscription)',
  EDCITY_IMPORT_AI_MATCH: 'Match',
  EDCITY_IMPORT_AI_MISMATCH: 'Mismatch',
  EDCITY_IMPORT_AI_UNCERTAIN: 'Uncertain',
  EDCITY_IMPORT_AI_UNAVAILABLE: 'AI unavailable',
  EDCITY_IMPORT_AI_SKIPPED: 'Not checked',
  EDCITY_IMPORT_DOWNLOAD_RESULT: 'Download mapping Excel (with school admins)',
  EDCITY_IMPORT_ADMIN_SUMMARY: 'School admins: {0} created, {1} already existed.',
  EDCITY_IMPORT_ADMIN_PASSWORD_NOTE: 'A new school admin password is shown only this once, in the table below and in the downloaded Excel. An existing account\'s password is stored as a one-way hash, so that cell is left blank unless the account still has a recoverable plaintext password.',
  EDCITY_IMPORT_ADMIN_PASSWORD_UNAVAILABLE: 'Existing account, password cannot be retrieved',
  EDCITY_IMPORT_ADMIN_USERNAME_TAKEN: 'Username already used by another account',
  EDCITY_IMPORT_ADMIN_FAILED: 'Could not create the school admin',
  EDCITY_IMPORT_COL_ADMIN_USER: 'School Admin Username',
  EDCITY_IMPORT_COL_ADMIN_PASSWORD: 'School Admin Password',

  // School Activity (school admins, role >= 2) — /api/activity/* over the
  // epack_activity_log table: staff, student and device sign-ins + LOCALE create / update /
  // delete / change-owner. Field labels are ACTIVITY_FIELD_<COLUMN>.
  SCHOOL_ACTIVITY_MENU: 'School Activity',
  SCHOOL_ACTIVITY_TITLE: 'School Activity Log',
  ACTIVITY_TAB_TEACHERS: 'Teachers',
  ACTIVITY_TAB_LOGINS: 'Sign-in activity',
  ACTIVITY_TAB_LOCALES: 'LOCALE activity',
  ACTIVITY_COL_TIME: 'Time',
  ACTIVITY_COL_TEACHER: 'Teacher',
  ACTIVITY_COL_ACTION: 'Action',
  ACTIVITY_COL_LOCALE: 'LOCALE',
  ACTIVITY_COL_DETAIL: 'Details',
  ACTIVITY_COL_METHOD: 'Sign-in method',
  ACTIVITY_COL_SURFACE: 'Where',
  ACTIVITY_COL_IP: 'IP address',
  ACTIVITY_COL_ROLE: 'Role',
  ACTIVITY_COL_LAST_LOGIN: 'Last sign-in',
  ACTIVITY_COL_LOGIN_COUNT: 'Sign-ins',
  ACTIVITY_COL_ACTION_COUNT: 'LOCALE actions',
  ACTIVITY_COL_LAST_ACTION: 'Last LOCALE action',
  ACTIVITY_FILTER_TEACHER: 'Teacher',
  ACTIVITY_FILTER_ACTION: 'Action',
  ACTIVITY_FILTER_ALL: 'All',
  ACTIVITY_FILTER_FROM: 'From',
  ACTIVITY_FILTER_TO: 'To',
  ACTIVITY_REFRESH: 'Refresh',
  ACTIVITY_EMPTY: 'No records',
  ACTIVITY_LOAD_FAILED: 'Could not load the activity log',
  ACTIVITY_TOTAL: '{0} record(s)',
  ACTIVITY_VIEW_LOGINS: 'Sign-ins',
  ACTIVITY_VIEW_ACTIONS: 'Actions',
  ACTIVITY_NEVER: 'Never',
  ACTIVITY_ACTION_CREATE: 'Create',
  ACTIVITY_ACTION_UPDATE: 'Update',
  ACTIVITY_ACTION_DELETE: 'Delete',
  ACTIVITY_ACTION_CHANGE_OWNER: 'Change owner',
  ACTIVITY_ACTION_LOGIN: 'Sign in',
  ACTIVITY_SURFACE_COMPOSER: 'Composer',
  ACTIVITY_SURFACE_APP: 'App',
  ACTIVITY_SURFACE_LEGACY: 'Composer (old)',
  ACTIVITY_METHOD_PASSWORD: 'Password',
  ACTIVITY_METHOD_GOOGLE: 'Google',
  ACTIVITY_METHOD_APPLE: 'Apple',
  ACTIVITY_METHOD_EDCITY: 'EdCity',
  ACTIVITY_METHOD_DEVICE: 'Device',
  ACTIVITY_DUPLICATED_FROM: 'Duplicated from LOCALE #{0}',
  ACTIVITY_DELETED_OWNER: 'Owner: #{0}',
  ACTIVITY_ROLE_0: 'Standard user',
  ACTIVITY_ROLE_1: 'Advanced user',
  ACTIVITY_ROLE_2: 'Administrator',
  ACTIVITY_ROLE_3: 'CLST Administrator',
  ACTIVITY_FIELD_NAME: 'Name',
  ACTIVITY_FIELD_DESCRIPTION: 'Description',
  ACTIVITY_FIELD_IS_SHARE: 'Share',
  ACTIVITY_FIELD_IS_READY: 'Publish',
  ACTIVITY_FIELD_IS_DUPLICATION_ALLOWED: 'Allow duplication',
  ACTIVITY_FIELD_TN_FILE_ID: 'Cover image',
  ACTIVITY_FIELD_KLA: 'KLA',
  ACTIVITY_FIELD_SUBJECT: 'Subject',
  ACTIVITY_FIELD_LANG: 'Language',
  ACTIVITY_FIELD_COLOR: 'Colour',
  ACTIVITY_FIELD_HS_REVEAL_CODE: 'Reveal code',
  ACTIVITY_FIELD_HS_REVEAL_CODE_ENABLED: 'Reveal code enabled',
  ACTIVITY_FIELD_IS_AUTO_SHARE_ASSESSMENT: 'Auto-share assessment',
  ACTIVITY_FIELD_IS_MANUAL_AI_ASSESSMENT: 'Manual AI assessment',
  ACTIVITY_FIELD_IS_MOOD_ENABLED: 'Mood',
  ACTIVITY_FIELD_IS_NUDGE_ENABLED: 'Nudge',
  ACTIVITY_FIELD_IS_CHAT_TEACHER_TO_STUDENT: 'Chat: teacher to student',
  ACTIVITY_FIELD_IS_CHAT_STUDENT_TO_STUDENT: 'Chat: student to student',
  ACTIVITY_FIELD_IS_CHAT_STUDENT_TO_TEACHER: 'Chat: student to teacher',
  ACTIVITY_FIELD_MAP_AREA: 'Map area',
  // Change owner (school admins, own school)
  CHANGE_OWNER: 'Change owner',
  CHANGE_OWNER_TITLE: 'Change LOCALE owner',
  CHANGE_OWNER_CURRENT: 'Current owner',
  CHANGE_OWNER_NEW: 'New owner',
  CHANGE_OWNER_HINT: 'Only staff accounts of this school can be chosen. The LOCALE stays in this school.',
  CHANGE_OWNER_CONFIRM: 'Change',
  CHANGE_OWNER_DONE: 'Owner changed',
  CHANGE_OWNER_FAILED: 'Could not change the owner',
  CHANGE_OWNER_INVALID: 'The new owner must be a staff account of this school',
  CHANGE_OWNER_NO_USERS: 'No other staff account in this school',

  // Admin Task — user management (what a SCHOOL admin, role 2, sees; platform
  // admins see the same pages plus the rest). Every label the panel prints on
  // Create User / User List and the edit / password / delete dialogs.
  ADMIN_ROLE_LABEL: 'Role',
  ADMIN_ROLE_0: 'Standard user',
  ADMIN_ROLE_1: 'Advanced user',
  ADMIN_ROLE_2: 'Administrator',
  ADMIN_ROLE_STUDENT: 'Student',
  ADMIN_ROLE_UNKNOWN: 'Unknown',
  ADMIN_SCHOOL_ID: 'School ID',
  ADMIN_SCHOOL_INFO: 'School',
  ADMIN_IMPORT_LATEST_SCHOOL: 'Import latest school ID',
  ADMIN_IMPORTED_SCHOOL_ID: 'Imported the latest school ID: {0}',
  ADMIN_NO_SCHOOL_FOUND: 'No school found',
  ADMIN_IMPORT_SCHOOL_FAILED: 'Could not fetch the latest school',
  ADMIN_BATCH_CREATE_USERS: 'Batch create users (CSV)',
  ADMIN_ERR_USERNAME_REQUIRED: 'Please enter a username',
  ADMIN_ERR_PASSWORD_REQUIRED: 'Please enter a password',
  ADMIN_ERR_PASSWORD_TOO_SHORT: 'The password must be at least 6 characters',
  ADMIN_ERR_SCHOOL_ID_REQUIRED: 'Please enter a school ID',
  ADMIN_CREATE_USER_FAILED: 'Failed to create the user',
  ADMIN_CHECK_INPUT: 'please check the details entered',
  ADMIN_CHECK_NETWORK: 'please check your connection or contact the system administrator',
  ADMIN_USER_SEARCH_PLACEHOLDER: 'username, display name or email',
  ADMIN_USER_SEARCH_HINT: 'Enter a keyword and click Search (username, display name or email)',
  ADMIN_USER_LIST_EMPTY: 'No users in this school',
  ADMIN_REFRESH_RESULTS: 'Refresh results',
  ADMIN_COL_ID: 'ID',
  ADMIN_COL_LAST_LOGIN: 'Last sign-in',
  ADMIN_EDIT_USER: 'Edit user',
  ADMIN_DELETE_USER: 'Delete user',
  ADMIN_ERR_SEARCH_REQUIRED: 'Please enter a search keyword',
  ADMIN_SEARCH_FOUND: 'Found {0} user(s)',
  ADMIN_SEARCH_EMPTY: 'No matching users',
  ADMIN_SEARCH_FAILED: 'Search failed',
  ADMIN_NEVER_LOGGED_IN: 'Never signed in',
  ADMIN_INVALID_DATE: 'Invalid date',
  ADMIN_DATE_FORMAT_ERROR: 'Date format error',
  ADMIN_PW_DIALOG_TITLE: 'Change user password',
  ADMIN_TARGET_USER: 'Target user',
  ADMIN_PASSWORD: 'Administrator password',
  ADMIN_PASSWORD_DESC: 'Enter your own administrator password to confirm your identity',
  ADMIN_NEW_USER_PASSWORD: 'New password for the user',
  ADMIN_PASSWORD_MIN_DESC: 'At least 6 characters',
  ADMIN_CONFIRM_NEW_PASSWORD: 'New password (again)',
  ADMIN_CONFIRM_NEW_PASSWORD_DESC: 'Enter the new password again',
  ADMIN_ERR_PASSWORDS_DIFFER: 'The passwords do not match',
  ADMIN_ERR_FILL_ALL: 'Please fill in every field',
  ADMIN_ERR_PASSWORD_MISMATCH: 'The new password and its confirmation do not match',
  ADMIN_ERR_NO_ADMIN_ID: 'Could not verify your account, please sign in again',
  ADMIN_PW_CHANGED: 'Password of {0} changed',
  ADMIN_PW_CHANGE_FAILED: 'Failed to change the password',
  ADMIN_ERR_ADMIN_PASSWORD_REQUIRED: 'Please enter your administrator password',
  ADMIN_WARNING: 'Warning',
  ADMIN_DELETE_WARNING: 'This renames the account to "Deleted-{0}"; the user will no longer be able to sign in.',
  ADMIN_CONFIRM_DELETE: 'Confirm delete',
  ADMIN_USER_DELETED: 'User {0} deleted',
  ADMIN_DELETE_FAILED: 'Failed to delete the user',
  ADMIN_USER_UPDATED: 'User {0} updated',
  ADMIN_UPDATE_FAILED: 'Failed to update the user',
  ADMIN_SAVE_CHANGES: 'Save changes',
};
